(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
    if(!customElements.get('collection-matching-set')){customElements.define('collection-matching-set',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.selects=[...this.querySelectorAll('[data-set-select]')];this.button=this.querySelector('[data-set-add]');this.message=this.querySelector('[data-set-message]');this.label=this.querySelector('[data-set-add-label]');this.selects.forEach(select=>select.addEventListener('change',()=>this.update()));this.button?.addEventListener('click',()=>this.add());this.update()}money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(Number(cents)/100)}catch{return `$${(Number(cents)/100).toFixed(2)}`}}update(){let price=0,compare=0;const showCompare=this.dataset.showCompare==='true';this.selects.forEach(select=>{const option=select.selectedOptions[0],key=select.dataset.setSelect,value=Number(option?.dataset.price||0),compareValue=Number(option?.dataset.compare||value);price+=value;compare+=compareValue;const priceNode=this.querySelector(`[data-set-price="${key}"]`),compareNode=this.querySelector(`[data-set-compare="${key}"]`);if(priceNode)priceNode.textContent=this.money(value);if(compareNode){compareNode.textContent=this.money(compareValue);compareNode.hidden=!showCompare||compareValue<=value}});const total=this.querySelector('[data-set-total]'),totalCompare=this.querySelector('[data-set-total-compare]');if(total)total.textContent=this.money(price);if(totalCompare){totalCompare.textContent=this.money(compare);totalCompare.hidden=!showCompare||compare<=price}}async add(){if(!this.button||this.selects.length<2)return;this.button.disabled=true;this.label.textContent=this.dataset.addingLabel;this.message.textContent='';const helper=window.Alpine?.store?.('xCartHelper'),payload={items:this.selects.map(select=>({id:Number(select.value),quantity:1,properties:{'_Matching set':'Collection feature'}}))};if(helper){payload.sections=helper.getSectionsToRender().map(section=>section.id).join(',');payload.sections_url=window.location.pathname}try{const endpoint=window.Eurus?.cart_add_url||`${window.Shopify?.routes?.root||'/'}cart/add.js`,response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)}),result=await response.json();if(!response.ok||result.status===422)throw new Error(result.description||this.dataset.errorLabel);if(helper&&result.sections)helper.reRenderSections(result.sections);document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));const miniCart=window.Alpine?.store?.('xMiniCart');if(miniCart)miniCart.openCart();this.label.textContent=this.dataset.addedLabel;this.message.textContent=this.dataset.addedLabel}catch(error){this.label.textContent=this.dataset.addLabel;this.message.textContent=error.message||this.dataset.errorLabel}finally{this.button.disabled=false}}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-ad-slideshow"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('onebone-ad-slideshow')) {
    customElements.define('onebone-ad-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.viewport = this.querySelector('.obads__viewport');
        this.slides = [...this.querySelectorAll('[data-obads-slide]')];
        this.dots = [...this.querySelectorAll('[data-obads-go]')];
        this.previous = this.querySelector('[data-obads-previous]');
        this.next = this.querySelector('[data-obads-next]');
        this.toggle = this.querySelector('[data-obads-toggle]');
        this.progress = this.querySelector('[data-obads-progress]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.duration = Math.max(200, Math.min(1200, Number(this.dataset.transitionDuration) || 600));
        this.userPaused = this.motion.matches || Boolean(window.Shopify?.designMode);
        this.hovered = this.focusPaused = this.pointerActive = this.navigating = this.settling = false;
        this.visible = false;
        this.active = 0;
        if (!this.viewport || !this.slides.length) return;
        const controls = this.querySelector('.obads__controls');
        if (controls) controls.hidden = false;
        const update = () => {
          const viewport = this.viewport.getBoundingClientRect();
          const center = viewport.left + viewport.width / 2;
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const delta = Math.abs(rect.left + rect.width / 2 - center);
            if (delta < distance) { distance = delta; this.active = index; }
          });
          this.dots.forEach((dot, index) => {
            if (index === this.active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (this.previous) this.previous.disabled = !this.autoplay && this.active === 0;
          if (this.next) this.next.disabled = !this.autoplay && this.active === this.slides.length - 1;
        };
        this.viewport.addEventListener('scroll', () => {
          this.settling = true;
          this.stopTimer();
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            this.settling = false;
            update();
            this.schedule();
          }, 150);
        }, { passive: true, signal });
        this.previous?.addEventListener('click', () => this.go(this.active - 1), { signal });
        this.next?.addEventListener('click', () => this.go(this.active + 1), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), { signal }));
        this.toggle?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.focusPaused = false;
          this.schedule();
        }, { signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.slides.length - 1);
          else this.go(this.active + (event.key === 'ArrowRight' ? direction : -direction));
        }, { signal });
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch' || this.dataset.pauseHover === 'false') return;
          this.hovered = true;
          this.schedule();
        }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.viewport.addEventListener('pointerdown', () => {
          this.pointerActive = true;
          this.cancelNavigation();
          this.schedule();
        }, { passive: true, signal });
        const release = () => {
          if (!this.pointerActive) return;
          this.pointerActive = false;
          this.schedule();
        };
        window.addEventListener('pointerup', release, { signal });
        window.addEventListener('pointercancel', release, { signal });
        this.addEventListener('focusin', (event) => {
          if (event.target !== this.toggle) this.focusPaused = true;
          this.schedule();
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) { this.focusPaused = false; this.schedule(); }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.userPaused = true; this.cancelNavigation(); }
          this.schedule();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.obadsSlide === event.detail.blockId);
          if (index < 0) return;
          this.userPaused = true;
          this.go(index, true);
        }, { signal });
        this.resize = new ResizeObserver(() => { update(); this.schedule(); });
        this.resize.observe(this.viewport);
        this.intersection = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (!this.visible) this.cancelNavigation();
          this.schedule();
        }, { threshold: 0.1 });
        this.intersection.observe(this);
        update();
        this.schedule();
      }
      stopTimer() {
        clearTimeout(this.timer);
        this.progressEffect?.cancel();
        if (this.progress) this.progress.hidden = true;
      }
      schedule() {
        this.stopTimer();
        if (this.toggle) {
          this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
          this.toggle.querySelector('[data-obads-toggle-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
        }
        if (!this.autoplay || this.userPaused || this.hovered || this.focusPaused || this.pointerActive || this.navigating || this.settling || !this.visible || document.hidden) return;
        const delay = Number(this.slides[this.active]?.dataset.obadsDuration) || this.interval;
        if (this.progress && !this.motion.matches) {
          this.progress.hidden = false;
          this.progressEffect = this.progress.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: delay, easing: 'linear', fill: 'forwards' });
        }
        this.timer = setTimeout(() => this.go((this.active + 1) % this.slides.length), delay);
      }
      cancelNavigation() {
        this.navigationId = (this.navigationId || 0) + 1;
        this.effect?.cancel();
        cancelAnimationFrame(this.scrollFrame);
        this.finishScroll?.();
        this.finishScroll = null;
        if (this.viewport) this.viewport.style.scrollSnapType = '';
        this.navigating = false;
      }
      async go(index, instant = false) {
        if (!this.slides.length) return;
        const target = this.autoplay ? (index + this.slides.length) % this.slides.length : Math.max(0, Math.min(index, this.slides.length - 1));
        this.stopTimer();
        this.cancelNavigation();
        const navigationId = this.navigationId;
        this.navigating = true;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const left = direction * target * this.viewport.clientWidth;
        const style = instant || this.motion.matches ? 'none' : this.dataset.transition || 'slide';
        const jump = () => this.viewport.scrollTo({ left, behavior: 'instant' });
        try {
          if (style === 'fade' && target !== this.active) {
            this.effect = this.viewport.animate([{ opacity: 1 }, { opacity: 0.12 }], { duration: this.duration / 2, easing: 'ease-in' });
            await this.effect.finished;
            if (navigationId !== this.navigationId) return;
            jump();
            this.effect = this.viewport.animate([{ opacity: 0.12 }, { opacity: 1 }], { duration: this.duration / 2, easing: 'ease-out' });
            await this.effect.finished;
          } else if (style === 'rise' && target !== this.active) {
            jump();
            this.effect = this.slides[target].firstElementChild.animate([
              { opacity: 0.2, transform: 'translateY(16px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: this.duration, easing: 'cubic-bezier(.22, 1, .36, 1)' });
            await this.effect.finished;
          } else if (style === 'slide' && target !== this.active) {
            const start = this.viewport.scrollLeft;
            const startTime = performance.now();
            this.viewport.style.scrollSnapType = 'none';
            await new Promise((resolve) => {
              this.finishScroll = resolve;
              const step = (now) => {
                if (navigationId !== this.navigationId) { resolve(); return; }
                const progress = Math.min(1, (now - startTime) / this.duration);
                this.viewport.scrollTo({ left: start + (left - start) * (1 - Math.pow(1 - progress, 3)), behavior: 'instant' });
                if (progress < 1) this.scrollFrame = requestAnimationFrame(step);
                else { jump(); resolve(); }
              };
              this.scrollFrame = requestAnimationFrame(step);
            });
          } else jump();
        } catch (error) {
          if (error.name !== 'AbortError') throw error;
        } finally {
          if (navigationId === this.navigationId) {
            this.finishScroll = null;
            this.viewport.style.scrollSnapType = '';
            this.navigating = false;
            this.active = target;
            this.schedule();
          }
        }
      }
      cleanup() {
        this.abort?.abort();
        this.stopTimer();
        this.cancelNavigation();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.frame);
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-body-fit-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__obFitReferenceReady) return;
    window.__obFitReferenceReady = true;
    const matrix = [
        { max: 179, s: ['-2', '-2', '-2', '-1', '-1', '-1', '-1'] },
        { max: 189, s: ['-1', '-1', '-1', '-1', '-1', '-1', '-1'] },
        { max: 199, s: ['0', '0', '-1', '-1', '-1', '-1', '-1'] },
        { max: 209, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 219, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 229, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 239, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 249, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 259, s: ['1', '1', '1', '0', '0', '0', '0'] },
        { max: 269, s: ['1', '1', '1', '1', '1', '1', '1'] },
        { max: 279, s: ['2', '1', '1', '1', '1', '1', '1'] },
        { max: 289, s: ['2', '2', '1', '1', '1', '1', '1'] },
        { max: 299, s: ['2', '2', '1', '1', '1', '1', '1'] },
        { max: 309, s: ['2', '2', '1', '1', '1', '1', '1'] },
        { max: 319, s: ['3', '3', '2', '2', '2', '1', '1'] },
        { max: 329, s: ['3', '3', '2', '2', '2', '2', '2'] },
        { max: 339, s: ['3', '3', '3', '3', '3', '3', '3'] },
        { max: 349, s: ['4', '4', '3', '3', '3', '3', '3'] },
        { max: 359, s: ['4', '4', '3', '3', '3', '3', '3'] },
        { max: 369, s: ['4', '4', '4', '4', '4', '4', '4'] },
        { max: 379, s: ['4', '4', '4', '4', '4', '4', '4'] },
        { max: 389, s: ['5', '5', '4', '4', '4', '3', '3'] },
        { max: 399, s: ['5', '5', '5', '4', '4', '4', '4'] },
        { max: 409, s: ['5', '5', '5', '5', '5', '5', '5'] },
        { max: 419, s: ['5', '5', '5', '5', '5', '5', '5'] },
        { max: 429, s: ['5', '5', '5', '5', '5', '5', '5'] },
        { max: 439, s: ['6', '5', '5', '5', '5', '5', '5'] },
        { max: 449, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 459, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 469, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 479, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 489, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 499, s: ['7', '7', '7', '7', '7', '7', '7'] },
        { max: Infinity, s: ['7', '7', '7', '7', '7', '7', '7'] },
      ],
      bottoms = [
        { max: 33, size: 'A' },
        { max: 37, size: 'B' },
        { max: 40, size: 'C' },
        { max: 44, size: 'D' },
        { max: 49, size: 'E' },
        { max: 54, size: 'F' },
        { max: 60, size: 'G' },
        { max: Infinity, size: 'H' },
      ],
      column = (h) => (h <= 68 ? 0 : h <= 71 ? 1 : h <= 74 ? 2 : h <= 77 ? 3 : h <= 80 ? 4 : h <= 83 ? 5 : 6),
      formatHeight = (h) => `${Math.floor(h / 12)}'${h % 12}\"`,
      init = (scope = document) =>
        scope.querySelectorAll('[data-obfr]').forEach((root) => {
          if (root.dataset.ready) return;
          root.dataset.ready = 'true';
          const height = root.querySelector('[data-obfr-height]'),
            weight = root.querySelector('[data-obfr-weight]'),
            waist = root.querySelector('[data-obfr-waist]'),
            heightOutput = root.querySelector('[data-obfr-height-output]'),
            weightOutput = root.querySelector('[data-obfr-weight-output]'),
            waistOutput = root.querySelector('[data-obfr-waist-output]'),
            topOutput = root.querySelector('[data-obfr-top]'),
            bottomOutput = root.querySelector('[data-obfr-bottom]'),
            matchName = root.querySelector('[data-obfr-match-name]'),
            matchStats = root.querySelector('[data-obfr-match-stats]'),
            modelWears = root.querySelector('[data-obfr-model-wears]'),
            people = [...root.querySelectorAll('[data-obfr-person]')];
          const selectPerson = (person) => {
            people.forEach((item) => item.classList.toggle('is-selected', item === person));
            root
              .querySelectorAll('[data-obfr-hit]')
              .forEach((hit) => hit.classList.toggle('is-selected', hit.dataset.obfrHit === person.dataset.obfrPerson));
            const name = person.querySelector('strong')?.textContent.trim() || '';
            if (matchName) matchName.textContent = name;
            if (matchStats)
              matchStats.textContent = `${formatHeight(Number(person.dataset.height))} · ${
                person.dataset.weight
              } lb · ${person.dataset.waist}\" waist`;
            if (modelWears)
              modelWears.textContent = `${name} wears top ${person.dataset.top} / bottom ${person.dataset.bottom}`;
          };
          const update = () => {
            const h = Number(height.value),
              w = Number(weight.value),
              ws = Number(waist.value),
              row = matrix.find((item) => w <= item.max) || matrix[matrix.length - 1],
              top = row.s[column(h)],
              bottom = (bottoms.find((item) => ws <= item.max) || bottoms[bottoms.length - 1]).size,
              closest = people.reduce((best, person) => {
                const score =
                  Math.abs(w - Number(person.dataset.weight)) + Math.abs(h - Number(person.dataset.height)) * 14;
                return !best || score < best.score ? { person, score } : best;
              }, null);
            heightOutput.textContent = formatHeight(h);
            weightOutput.textContent = `${w} lb`;
            waistOutput.textContent = `${ws} in`;
            topOutput.textContent = top;
            bottomOutput.textContent = bottom;
            if (closest) selectPerson(closest.person);
          };
          [height, weight, waist].forEach((input) => input.addEventListener('input', update));
          people.forEach((person) =>
            person.addEventListener('click', () => {
              height.value = person.dataset.height;
              weight.value = person.dataset.weight;
              waist.value = person.dataset.waist;
              update();
            })
          );
          update();
        });
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-category-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOneBoneCategorySections(container = document) {
      const sections = container.querySelectorAll('[data-ob-category-section]');

      sections.forEach((section) => {
        if (section.dataset.obInitialized === 'true') return;

        const rail = section.querySelector('[data-ob-category-rail]');
        const cards = Array.from(section.querySelectorAll('[data-ob-category-card]'));
        const progressItems = Array.from(section.querySelectorAll('[data-ob-progress-item]'));
        const enableHover = section.dataset.hoverExpand === 'true';
        const inactiveStills = section.dataset.inactiveStills === 'true';

        if (!rail || cards.length === 0) return;

        section.dataset.obInitialized = 'true';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let sectionIsVisible = false;

        function syncCardMedia() {
          cards.forEach((card) => {
            const shouldPlay = sectionIsVisible && card.classList.contains('is-active') && !reduceMotion;

            card.querySelectorAll('.ob-category-card__video').forEach((video) => {
              const isVisibleSource = window.getComputedStyle(video).display !== 'none';

              if (shouldPlay && isVisibleSource) {
                video.play().catch(() => {});
              } else {
                video.pause();
                if (inactiveStills && video.readyState > 0) video.currentTime = 0;
              }
            });
          });
        }

        function setActiveCard(activeCard) {
          cards.forEach((card, index) => {
            const isActive = card === activeCard;
            card.classList.toggle('is-active', isActive);
            card.setAttribute('aria-current', isActive ? 'true' : 'false');

            if (progressItems[index]) {
              progressItems[index].classList.toggle('is-active', isActive);
            }
          });

          syncCardMedia();
        }

        cards.forEach((card) => {
          if (enableHover) {
            card.addEventListener('pointerenter', () => setActiveCard(card));
          }

          card.addEventListener('focusin', () => setActiveCard(card));
          card.addEventListener('click', (event) => {
            if (!event.target.closest('a')) setActiveCard(card);
          });
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              setActiveCard(card);
            }
          });
        });

        let scrollFrame = null;

        rail.addEventListener(
          'scroll',
          () => {
            if (!window.matchMedia('(max-width: 900px)').matches) return;
            if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

            scrollFrame = window.requestAnimationFrame(() => {
              const railLeft = rail.getBoundingClientRect().left;
              let activeCard = cards[0];
              let smallestDistance = Number.POSITIVE_INFINITY;

              cards.forEach((card) => {
                const distance = Math.abs(card.getBoundingClientRect().left - railLeft);
                if (distance < smallestDistance) {
                  smallestDistance = distance;
                  activeCard = card;
                }
              });

              setActiveCard(activeCard);
            });
          },
          { passive: true }
        );

        const mediaObserver = new IntersectionObserver(
          (entries) => {
            sectionIsVisible = entries.some((entry) => entry.isIntersecting);
            syncCardMedia();
          },
          { threshold: 0.15 }
        );

        mediaObserver.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOneBoneCategorySections());
    } else {
      initOneBoneCategorySections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOneBoneCategorySections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-category-micro-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOBMicroNav(container = document) {
      const sections = container.querySelectorAll('[data-ob-micro-nav]');

      sections.forEach((section) => {
        if (section.dataset.obMicroInitialized === 'true') return;

        const rail = section.querySelector('[data-ob-micro-rail]');
        const railWrap = section.querySelector('.ob-micro-nav__rail-wrap');
        const items = Array.from(section.querySelectorAll('[data-ob-micro-item]'));
        const prev = section.querySelector('[data-ob-micro-prev]');
        const next = section.querySelector('[data-ob-micro-next]');

        if (!rail || items.length === 0) return;

        section.dataset.obMicroInitialized = 'true';

        function setActiveItem(activeItem) {
          items.forEach((item) => {
            const isActive = item === activeItem;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'page' : 'false');
          });
        }

        function scrollRail(direction) {
          const amount = Math.max(rail.clientWidth * 0.72, 220);
          rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
        }

        function updateOverflowCue() {
          if (!railWrap) return;

          const maxScroll = Math.max(rail.scrollWidth - rail.clientWidth, 0);
          let state = 'none';

          if (maxScroll > 2) {
            if (rail.scrollLeft >= maxScroll - 2) {
              state = 'end';
            } else if (rail.scrollLeft > 2) {
              state = 'middle';
            } else {
              state = 'start';
            }
          }

          railWrap.dataset.obOverflow = state;
        }

        items.forEach((item) => {
          item.addEventListener('click', () => setActiveItem(item));
        });

        if (prev) {
          prev.addEventListener('click', () => scrollRail(-1));
        }

        if (next) {
          next.addEventListener('click', () => scrollRail(1));
        }

        rail.addEventListener('scroll', updateOverflowCue, { passive: true });
        window.addEventListener('resize', updateOverflowCue, { passive: true });

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(updateOverflowCue);
          resizeObserver.observe(rail);
        }

        updateOverflowCue();

        const currentPath = window.location.pathname.replace(/\/$/, '');
        const currentUrl = window.location.href.replace(/\/$/, '');
        const matchedItem = items.find((item) => {
          const itemHref = item.href.replace(/\/$/, '');
          const itemPath = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '');
          return itemHref === currentUrl || itemPath === currentPath;
        });

        if (matchedItem) {
          setActiveItem(matchedItem);
          matchedItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOBMicroNav());
    } else {
      initOBMicroNav();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOBMicroNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-featured-for-him"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-obfp-section]');
    roots.forEach((root) => {
      if (root.dataset.obfpReady) return;
      root.dataset.obfpReady = 'true';
      const variantsNode = root.querySelector('[data-obfp-variants]'),
        form = root.querySelector('[data-obfp-form]');
      if (!variantsNode || !form) return;
      const variants = JSON.parse(variantsNode.textContent),
        variantInput = form.querySelector('[data-obfp-variant-id]'),
        inputs = [...form.querySelectorAll('[data-obfp-option-input]')],
        price = root.querySelector('[data-obfp-price]'),
        compare = root.querySelector('[data-obfp-compare]'),
        button = root.querySelector('[data-obfp-submit]'),
        buttonLabel = root.querySelector('[data-obfp-submit-label]'),
        buttonPrice = root.querySelector('[data-obfp-button-price]'),
        message = root.querySelector('[data-obfp-message]'),
        productLink = root.querySelector('[data-obfp-product-link]'),
        sticky = root.querySelector('[data-obfp-sticky]'),
        stickyButton = root.querySelector('[data-obfp-sticky-button]'),
        stickyLabel = root.querySelector('[data-obfp-sticky-label]'),
        stickyPrice = root.querySelector('[data-obfp-sticky-price]'),
        stickyVariant = root.querySelector('[data-obfp-sticky-variant]'),
        viewport = root.querySelector('[data-obfp-viewport]'),
        slides = [...root.querySelectorAll('[data-obfp-slide]')],
        thumbs = [...root.querySelectorAll('[data-obfp-thumbnail]')],
        current = root.querySelector('[data-obfp-current]');
      let activeVariant = variants.find((v) => String(v.id) === String(variantInput.value)) || variants[0],
        activeSlide = 0,
        buttonInView = true;
      const inlineColours = root.hasAttribute('data-obfp-inline-colours') && Boolean(root.querySelector('.obfp__linked-swatches'));
      let colourLoading = false;
      let cartAdding = false;
      const labels = {
          add: root.dataset.addLabel,
          sold: root.dataset.soldLabel,
          adding: root.dataset.addingLabel,
          added: root.dataset.addedLabel,
          error: root.dataset.errorLabel,
          fitSelected: root.dataset.fitSelected,
          fitUnavailable: root.dataset.fitUnavailable,
          fitRecommendation: root.dataset.fitRecommendation,
        },
        withSize = (template, size) => template.replace('[size]', size),
        selectedOptions = () => {
          const groups = [...form.querySelectorAll('[data-obfp-option]')];
          return groups
            .map((group) => group.querySelector('[data-obfp-option-input]:checked')?.value)
            .filter((value) => value !== undefined);
        },
        findVariant = () => {
          if (!form.querySelector('[data-obfp-option]')) {
            return variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants.find((variant) => variant.available) || variants[0];
          }
          const selected = selectedOptions();
          return variants.find(
            (variant) =>
              variant.options.length === selected.length &&
              variant.options.every((value, index) => value === selected[index])
          );
        },
        showSlide = (index) => {
          if (!viewport || !slides.length) return;
          activeSlide = Math.max(0, Math.min(index, slides.length - 1));
          slides[activeSlide].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === activeSlide);
            thumb.setAttribute('aria-pressed', i === activeSlide ? 'true' : 'false');
          });
          if (current) current.textContent = String(activeSlide + 1);
          if (inlineColours) root.querySelectorAll('[data-obfp-dot]').forEach((dot, index) =>
            dot.classList.toggle('is-active', index === activeSlide));
        },
        showMedia = (id) => {
          if (!id) return;
          const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(id));
          if (index >= 0) showSlide(index);
        },
        setAvailability = () => {
          const selected = selectedOptions();
          inputs.forEach((input) => {
            const position = Number(input.dataset.optionPosition) - 1,
              candidate = [...selected];
            candidate[position] = input.value;
            const available = variants.some(
              (variant) =>
                variant.available &&
                variant.options.every((value, index) => candidate[index] === undefined || value === candidate[index])
            );
            input.disabled = !available;
            input.closest('label')?.classList.toggle('is-unavailable', !available);
          });
        },
        update = () => {
          if (inlineColours && (colourLoading || cartAdding)) return;
          const variant = findVariant();
          activeVariant = variant || null;
          root.dataset.soldOut = String(!variant?.available);
          setAvailability();
          form.querySelectorAll('[data-obfp-option]').forEach((group) => {
            const selectedLabel = group.querySelector('[data-obfp-option-value]');
            if (selectedLabel) selectedLabel.textContent = group.querySelector('input:checked')?.value || '';
          });
          if (!variant) {
            variantInput.value = '';
            button.disabled = true;
            if (stickyButton) stickyButton.disabled = true;
            message.textContent = labels.sold;
            if (inlineColours) {
              buttonLabel.textContent = root.dataset.chooseLabel;
              buttonPrice.textContent = '';
              if (stickyLabel) stickyLabel.textContent = root.dataset.chooseLabel;
              if (stickyPrice) stickyPrice.textContent = '';
              if (stickyVariant) stickyVariant.textContent = '';
              message.textContent = root.dataset.chooseLabel;
            }
            return;
          }
          variantInput.value = variant.id;
          price.textContent = variant.price_formatted;
          price.classList.toggle('is-sale', variant.compare_at_price > variant.price);
          if (variant.compare_at_price > variant.price) {
            compare.textContent = variant.compare_at_price_formatted;
            compare.classList.remove('is-hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('is-hidden');
          }
          const available = variant.available;
          if (inlineColours && fitMessage) {
            const sizeGroup = [...form.querySelectorAll('[data-obfp-option]')].find((group) => group.dataset.optionName.toLowerCase().includes('size'));
            const size = sizeGroup?.querySelector('input:checked')?.value;
            if (size) fitMessage.textContent = withSize(available ? labels.fitSelected : labels.fitUnavailable, size);
          }
          button.disabled = !available;
          buttonLabel.textContent = available ? labels.add : labels.sold;
          buttonPrice.textContent = available ? variant.price_formatted : '';
          if (stickyButton) stickyButton.disabled = !available;
          if (stickyLabel) stickyLabel.textContent = available ? labels.add : labels.sold;
          if (stickyPrice) stickyPrice.textContent = available ? variant.price_formatted : '';
          if (stickyVariant) stickyVariant.textContent = variant.title;
          if (productLink) productLink.href = `${productLink.href.split('?')[0]}?variant=${variant.id}`;
          message.textContent = '';
          showMedia(variant.featured_media_id);
        };
      inputs.forEach((input) => input.addEventListener('change', update));
      if (inlineColours) {
        const swatchWrap = root.querySelector('.obfp__linked-swatches');
        const swatches = [...swatchWrap.querySelectorAll('a[data-swatch-name]')];
        let currentSwatch = swatches.find((swatch) => swatch.classList.contains('is-active'));
        let requestNumber = 0;
        let controller;
        const optionKind = (name) => {
          const normalized = name.trim().toLowerCase();
          return normalized.match(/\(([^()]*)\)\s*$/)?.[1] || normalized;
        };
        const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: root.dataset.currency, currencyDisplay: 'narrowSymbol',
        }).format(cents / 100);
        const setSwatches = (selected) => {
          currentSwatch = selected;
          swatches.forEach((swatch) => {
            const active = swatch === selected;
            swatch.classList.toggle('is-active', active);
            swatch.setAttribute('aria-pressed', String(active));
          });
          swatchWrap.querySelectorAll('[data-swatch-group]').forEach((group) => {
            const active = group.querySelector('.is-active');
            group.dataset.defaultName = active?.dataset.swatchName || '';
            const label = group.closest('.x-swatch-section').querySelector('[data-swatch-label]');
            if (label) label.textContent = group.dataset.defaultName;
          });
        };
        swatchWrap.querySelectorAll('[data-swatch-label]').forEach((label) => {
          new MutationObserver(() => {
            const expected = label.closest('.x-swatch-section').contains(currentSwatch) ? currentSwatch.dataset.swatchName : '';
            if (label.textContent !== expected) label.textContent = expected;
          }).observe(label, { childList: true, characterData: true, subtree: true });
        });
        const setBusy = (busy) => {
          colourLoading = busy;
          root.setAttribute('aria-busy', String(busy));
          form.querySelector('.obfp__options')?.toggleAttribute('inert', busy);
          if (busy) {
            button.disabled = true;
            if (stickyButton) stickyButton.disabled = true;
            message.textContent = root.dataset.colourLoading;
          }
        };
        swatches.forEach((swatch) => {
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('aria-pressed', String(swatch.classList.contains('is-active')));
          swatch.addEventListener('keydown', (event) => {
            if (event.key === ' ') { event.preventDefault(); swatch.click(); }
          });
        });
        swatchWrap.addEventListener('click', async (event) => {
          const swatch = event.target.closest('a[data-swatch-name]');
          if (!swatch || !swatchWrap.contains(swatch)) return;
          event.preventDefault();
          if (cartAdding) return;
          const request = ++requestNumber;
          controller?.abort();
          controller = new AbortController();
          const requestController = controller;
          const timeout = setTimeout(() => requestController.abort(), 15000);
          const saved = [...form.querySelectorAll('[data-obfp-option]')].map((group) =>
            group.querySelector('input:checked')?.value);
          setBusy(true);
          try {
            const url = new URL(swatch.href, location.origin);
            if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error();
            url.pathname += '.js';
            url.search = '';
            const response = await fetch(url, { signal: requestController.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error();
            const product = await response.json();
            if (!product.id || !product.variants?.length || !product.images?.length) throw new Error();
            if (request !== requestNumber) return;
            const groups = [...form.querySelectorAll('[data-obfp-option]')];
            const defaultOnly = product.variants.length === 1 && product.options.length === 1 && product.options[0].name === 'Title';
            if (!(defaultOnly && groups.length === 0) && (product.options.length !== groups.length || product.options.some((option, index) =>
              optionKind(option.name) !== optionKind(groups[index].dataset.optionName)))) throw new Error();
            const nextVariants = product.variants.map((variant) => ({
              ...variant,
              price_formatted: money(variant.price),
              compare_at_price_formatted: money(variant.compare_at_price || 0),
              featured_media_id: variant.featured_media?.id || 0,
            }));
            const selected = saved;
            const sizeValue = (value) => String(value ?? '').trim().replace(/^size\s*/i, '').replace(/^(-?\d+)\s*\([^)]*\)$/, '$1');
            const preserved = nextVariants.find((variant) =>
              variant.options.every((value, index) => product.options[index].name.toLowerCase().includes('size')
                ? sizeValue(value) === sizeValue(selected[index]) : value === selected[index]));
            const imageMedia = (product.media || []).filter((media) => media.media_type === 'image');
            const images = product.images.slice(0, Number(root.dataset.galleryLimit) || 1);
            const imageUrl = (source, width) => {
              const url = new URL(source, location.origin); url.searchParams.set('width', width); return url.href;
            };
            const image = new Image();
            image.src = imageUrl(images[0], 960);
            await Promise.race([image.decode(), new Promise((_, reject) => setTimeout(reject, 10000))]);
            if (request !== requestNumber) return;
            const newSlides = images.map((source, index) => {
              const slide = document.createElement('div');
              slide.className = 'obfp__slide'; slide.dataset.obfpSlide = '';
              slide.dataset.mediaId = imageMedia[index]?.id || '';
              slide.setAttribute('aria-label', `${index + 1} / ${images.length}`);
              const img = document.createElement('img');
              img.className = 'obfp__image'; img.alt = `${product.title} — ${index + 1}`;
              img.src = imageUrl(source, 1600);
              img.srcset = [480,720,960,1200,1600].map((width) => `${imageUrl(source,width)} ${width}w`).join(', ');
              img.sizes = '(min-width: 990px) 52vw, 100vw'; img.loading = index ? 'lazy' : 'eager';
              img.width = imageMedia[index]?.preview_image?.width || image.naturalWidth;
              img.height = imageMedia[index]?.preview_image?.height || image.naturalHeight;
              slide.append(img); return slide;
            });
            variants.splice(0, variants.length, ...nextVariants);
            variantsNode.textContent = JSON.stringify(nextVariants);
            const displayVariant = preserved || nextVariants[0];
            price.textContent = displayVariant.price_formatted;
            price.classList.toggle('is-sale', displayVariant.compare_at_price > displayVariant.price);
            compare.textContent = displayVariant.compare_at_price > displayVariant.price ? displayVariant.compare_at_price_formatted : '';
            compare.classList.toggle('is-hidden', !(displayVariant.compare_at_price > displayVariant.price));
            root.dataset.productId = product.id;
            if (defaultOnly) variantInput.value = displayVariant.id;
            if (root.dataset.productTitleSource === 'product_title') {
              const title = root.querySelector('.obfp__product-title');
              const stickyTitle = sticky?.querySelector('strong');
              if (title) title.textContent = product.title;
              if (stickyTitle) stickyTitle.textContent = product.title;
            }
            const productId = form.querySelector('[name="product-id"]');
            if (productId) productId.value = product.id;
            if (productLink) productLink.href = swatch.href;
            groups.forEach((group, index) => {
              group.dataset.optionName = product.options[index].name;
              const legend = group.querySelector('legend');
              if (legend?.firstChild?.nodeType === Node.TEXT_NODE) {
                legend.firstChild.textContent = product.options[index].name + (legend.querySelector('[data-obfp-option-value]') ? ': ' : '');
              }
              const values = [...new Set(nextVariants.map((variant) => variant.options[index]))];
              const container = group.querySelector('.obfp__option-values');
              container.replaceChildren(...values.map((value) => {
                const label = document.createElement('label'); label.className = 'obfp__option-label';
                const input = document.createElement('input'); input.type = 'radio';
                input.name = `obfp-option-${root.dataset.obfpSection}-${index + 1}`;
                input.value = value; input.setAttribute('aria-label', value);
                input.dataset.obfpOptionInput = ''; input.dataset.optionPosition = index + 1;
                input.checked = Boolean(preserved && preserved.options[index] === value);
                input.addEventListener('change', update);
                const text = document.createElement('span'); text.textContent = value;
                label.append(input, text); return label;
              }));
            });
            inputs.splice(0, inputs.length, ...form.querySelectorAll('[data-obfp-option-input]'));
            viewport.replaceChildren(...newSlides); viewport.scrollTo({ left: 0, behavior: 'instant' });
            slides.splice(0, slides.length, ...newSlides); activeSlide = 0;
            const thumbnailWrap = root.querySelector('.obfp__thumbnails');
            if (thumbnailWrap) {
              const newThumbs = newSlides.map((slide, index) => {
                const thumb = document.createElement('button'); thumb.type = 'button';
                thumb.className = `obfp__thumbnail${index ? '' : ' is-active'}`;
                thumb.dataset.obfpThumbnail = index; thumb.setAttribute('aria-label', slide.getAttribute('aria-label'));
                thumb.setAttribute('aria-pressed', String(index === 0));
                const img = slide.querySelector('img').cloneNode(); img.className = 'obfp__thumbnail-image';
                img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = imageUrl(images[index],180);
                thumb.append(img); thumb.addEventListener('click', () => showSlide(index)); return thumb;
              });
              thumbnailWrap.replaceChildren(...newThumbs); thumbs.splice(0, thumbs.length, ...newThumbs);
            }
            const dots = root.querySelector('.obfp__gallery-dots');
            if (dots) dots.replaceChildren(...images.map((_, index) => {
              const dot = document.createElement('span'); dot.dataset.obfpDot = index;
              dot.classList.toggle('is-active', index === 0); return dot;
            }));
            if (current) current.parentElement.replaceChildren(current, document.createTextNode(` / ${images.length}`));
            setSwatches(swatch);
            setBusy(false); update();
            if (!preserved && fitMessage) fitMessage.textContent = root.dataset.chooseLabel;
          } catch (error) {
            if (request !== requestNumber) return;
            setBusy(false); update();
            message.textContent = root.dataset.colourError;
            setSwatches(swatches.find((item) => item.classList.contains('is-active')));
          } finally {
            clearTimeout(timeout);
            if (request === requestNumber && colourLoading) setBusy(false);
          }
        });
      }
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.obfpThumbnail))));
      root.querySelector('[data-obfp-previous]')?.addEventListener('click', () => showSlide(activeSlide - 1));
      root.querySelector('[data-obfp-next]')?.addEventListener('click', () => showSlide(activeSlide + 1));
      if (viewport) {
        let ticking = false;
        viewport.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              const width = viewport.clientWidth || 1,
                position = Math.round(viewport.scrollLeft / width);
              if (position !== activeSlide) {
                activeSlide = position;
                thumbs.forEach((thumb, i) => {
                  thumb.classList.toggle('is-active', i === activeSlide);
                  thumb.setAttribute('aria-pressed', i === activeSlide ? 'true' : 'false');
                });
                if (current) current.textContent = String(activeSlide + 1);
                if (inlineColours) root.querySelectorAll('[data-obfp-dot]').forEach((dot, index) =>
                  dot.classList.toggle('is-active', index === activeSlide));
              }
              ticking = false;
            });
          },
          { passive: true }
        );
      }
      const emailCodeLink = root.querySelector('[data-obfp-email-code]');
      emailCodeLink?.addEventListener('click', (event) => {
        event.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'W5sKSn']);
      });
      const fit = root.querySelector('[data-obfp-fit]'),
        openFit = root.querySelector('[data-obfp-open-fit]'),
        height = root.querySelector('[data-obfp-height]'),
        weight = root.querySelector('[data-obfp-weight]'),
        heightOutput = root.querySelector('[data-obfp-height-output]'),
        weightOutput = root.querySelector('[data-obfp-weight-output]'),
        fitSize = root.querySelector('[data-obfp-fit-size]'),
        fitMessage = root.querySelector('[data-obfp-fit-message]'),
        matrix = [
          { max: 179, s: ['-2', '-2', '-2', '-1', '-1', '-1', '-1'] },
          { max: 189, s: ['-1', '-1', '-1', '-1', '-1', '-1', '-1'] },
          { max: 199, s: ['0', '0', '-1', '-1', '-1', '-1', '-1'] },
          { max: 209, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 219, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 229, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 239, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 249, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 259, s: ['1', '1', '1', '0', '0', '0', '0'] },
          { max: 269, s: ['1', '1', '1', '1', '1', '1', '1'] },
          { max: 279, s: ['2', '1', '1', '1', '1', '1', '1'] },
          { max: 289, s: ['2', '2', '1', '1', '1', '1', '1'] },
          { max: 299, s: ['2', '2', '1', '1', '1', '1', '1'] },
          { max: 309, s: ['2', '2', '1', '1', '1', '1', '1'] },
          { max: 319, s: ['3', '3', '2', '2', '2', '1', '1'] },
          { max: 329, s: ['3', '3', '2', '2', '2', '2', '2'] },
          { max: 339, s: ['3', '3', '3', '3', '3', '3', '3'] },
          { max: 349, s: ['4', '4', '3', '3', '3', '3', '3'] },
          { max: 359, s: ['4', '4', '3', '3', '3', '3', '3'] },
          { max: 369, s: ['4', '4', '4', '4', '4', '4', '4'] },
          { max: 379, s: ['4', '4', '4', '4', '4', '4', '4'] },
          { max: 389, s: ['5', '5', '4', '4', '4', '3', '3'] },
          { max: 399, s: ['5', '5', '5', '4', '4', '4', '4'] },
          { max: 409, s: ['5', '5', '5', '5', '5', '5', '5'] },
          { max: 419, s: ['5', '5', '5', '5', '5', '5', '5'] },
          { max: 429, s: ['5', '5', '5', '5', '5', '5', '5'] },
          { max: 439, s: ['6', '5', '5', '5', '5', '5', '5'] },
          { max: 449, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 459, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 469, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 479, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 489, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 499, s: ['7', '7', '7', '7', '7', '7', '7'] },
          { max: Infinity, s: ['7', '7', '7', '7', '7', '7', '7'] },
        ],
        heightColumn = (value) =>
          value <= 68 ? 0 : value <= 71 ? 1 : value <= 74 ? 2 : value <= 77 ? 3 : value <= 80 ? 4 : value <= 83 ? 5 : 6,
        normalize = (value) =>
          String(value)
            .toLowerCase()
            .replace(/^size\s*/, '')
            .trim(),
        recommend = () => {
          if (inlineColours && (colourLoading || cartAdding)) return;
          if (!height || !weight) return;
          const inches = Number(height.value),
            pounds = Number(weight.value),
            row = matrix.find((range) => pounds <= range.max) || matrix[matrix.length - 1],
            size = row.s[heightColumn(inches)];
          heightOutput.textContent = `${Math.floor(inches / 12)}'${inches % 12}\"`;
          weightOutput.textContent = pounds >= 500 ? '500 lb+' : `${pounds} lb`;
          fitSize.textContent = size;
          const sizeGroup = [...form.querySelectorAll('[data-obfp-option]')].find((group) =>
            group.dataset.optionName.toLowerCase().includes('size')
          );
          const sizeInput = sizeGroup
            ? [...sizeGroup.querySelectorAll('[data-obfp-option-input]')].find(
                (input) => normalize(input.value) === normalize(size)
              )
            : null;
          if (sizeInput && !sizeInput.disabled) {
            if (!sizeInput.checked) {
              sizeInput.checked = true;
              sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            fitMessage.textContent = withSize(labels.fitSelected, size);
          } else if (sizeInput) {
            fitMessage.textContent = withSize(labels.fitUnavailable, size);
          } else {
            fitMessage.textContent = withSize(labels.fitRecommendation, size);
          }
        };
      openFit?.addEventListener('click', () => {
        fit.open = !fit.open;
        openFit.setAttribute('aria-expanded', fit.open ? 'true' : 'false');
        if (fit.open) fit.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      fit?.addEventListener('toggle', () => openFit?.setAttribute('aria-expanded', fit.open ? 'true' : 'false'));
      height?.addEventListener('input', recommend);
      weight?.addEventListener('input', recommend);
      recommend();

      /*
        The theme's own fit picker works out a size and publishes it; the
        product page preselects from that, and so should this section. It
        cannot share the product page's markup — that machinery keys off
        .js-option-size and a variant id, and these are plain radios — so it
        listens for the same event and matches on the value it already knows
        how to compare.
      */
      const fitScope = root.dataset.obfpFitScope === 'bottom' ? 'bottom' : 'top';
      const applyStoredFit = (profile) => {
        if (inlineColours && (colourLoading || cartAdding)) return;
        if (!profile || !profile.captured) return;
        const wanted = profile[fitScope];
        if (!wanted) return;
        const sizeGroup = [...form.querySelectorAll('[data-obfp-option]')].find((group) =>
          group.dataset.optionName.toLowerCase().includes('size')
        );
        if (!sizeGroup) return;
        const input = [...sizeGroup.querySelectorAll('[data-obfp-option-input]')].find(
          (candidate) => normalize(candidate.value) === normalize(wanted)
        );
        if (!input || input.disabled || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const readFitProfile = () => window.OneBoneFit && window.OneBoneFit.getProfile();
      document.addEventListener('onebone:fit:change', (event) => applyStoredFit(event.detail));
      // fit-finder.js is a separate bundle and may load after this one, so take
      // whichever of the two arrives second.
      document.addEventListener('onebone:fit:ready', () => applyStoredFit(readFitProfile()));
      applyStoredFit(readFitProfile());
      form.addEventListener('submit', async (event) => {
        if (inlineColours && (colourLoading || cartAdding)) { event.preventDefault(); return; }
        if (root.dataset.cartEnabled === 'false') { event.preventDefault(); return; }
        if (!activeVariant || !activeVariant.available) {
          event.preventDefault();
          message.textContent = labels.sold;
          form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();
          return;
        }
        if (!window.fetch) return;
        event.preventDefault();
        button.disabled = true;
        if (inlineColours) cartAdding = true;
        message.textContent = labels.adding;
        const data = new FormData(form);
        try {
          const helper = window.Alpine?.store?.('xCartHelper');
          if (helper) {
            data.append(
              'sections',
              helper.getSectionsToRender().map((section) => section.id)
            );
            data.append('sections_url', window.location.pathname);
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: data,
            }),
            result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || labels.error);
          if (helper && result.sections) helper.reRenderSections(result.sections);
          const notice = window.Alpine?.store?.('xCartNoti');
          if (notice?.enable) notice.setItem(result);
          const miniCart = window.Alpine?.store?.('xMiniCart');
          if (miniCart && !notice?.enable) miniCart.openCart();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          message.textContent = labels.added;
        } catch (error) {
          message.textContent = error.message || labels.error;
        } finally {
          if (inlineColours) cartAdding = false;
          button.disabled = !activeVariant?.available;
        }
      });
      stickyButton?.addEventListener('click', () => {
        if (button.disabled) {
          form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        button.click();
      });
      if (sticky && button) {
        const landingAnchor = root.querySelector('[data-obfp-anchor]');
        let anchorOffset = 12;
        const measureAnchorOffset = () => {
          const header = document.getElementById('sticky-header-content');
          anchorOffset = (header ? header.getBoundingClientRect().height : 0) + 12;
          if (landingAnchor) landingAnchor.style.scrollMarginTop = `${anchorOffset}px`;
        };
        if (landingAnchor) measureAnchorOffset();
        const observer = new IntersectionObserver(
            (entries) => {
              buttonInView = entries[0].isIntersecting;
              updateSticky();
            },
            { threshold: 0.1 }
          ),
          updateSticky = () => {
            const rect = root.getBoundingClientRect(),
              sectionVisible = rect.top < window.innerHeight && rect.bottom > 0,
              anchorReached = landingAnchor
                ? landingAnchor.getBoundingClientRect().top <= anchorOffset + 2
                : rect.top < 0,
              show = sectionVisible && !buttonInView && anchorReached;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          };
        observer.observe(button);
        window.addEventListener('scroll', updateSticky, { passive: true });
        if (landingAnchor) {
          window.addEventListener('resize', () => {
            measureAnchorOffset();
            updateSticky();
          }, { passive: true });
        }
      }
      update();
    });
  })();
  (() => {
    document.querySelectorAll('[data-obfp-matching]').forEach((root) => {
      if (root.dataset.obfpMatchingReady) return;
      root.dataset.obfpMatchingReady = 'true';

      const productCards = [...root.querySelectorAll('[data-obfp-set-product]')];
      const selects = productCards.map((card) => card.querySelector('[data-obfp-set-select]'));
      const addButton = root.querySelector('[data-obfp-set-add]');
      const addLabel = root.querySelector('[data-obfp-set-add-label]');
      const total = root.querySelector('[data-obfp-set-total]');
      const compareTotal = root.querySelector('[data-obfp-set-compare-total]');
      const message = root.querySelector('[data-obfp-set-message]');
      const initialLabel = addLabel?.textContent.trim() || 'Add the set to bag';
      const normalize = (value) =>
        String(value || '')
          .toLowerCase()
          .replace(/^size\s*/, '')
          .trim();
      const formatMoney = (cents) => {
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'CAD' }).format(
          cents / 100
        );
      };

      const setGalleries = productCards.map((card) => {
        const viewport = card.querySelector('[data-obfp-set-viewport]');
        const slides = [...card.querySelectorAll('[data-obfp-set-slide]')];
        const dots = [...card.querySelectorAll('[data-obfp-set-dot]')];
        const previous = card.querySelector('[data-obfp-set-previous]');
        const next = card.querySelector('[data-obfp-set-next]');
        return { viewport, slides, dots, previous, next, index: 0, ticking: false };
      });

      const setGalleryIndex = (gallery, index, behavior = 'smooth') => {
        if (!gallery?.viewport || gallery.slides.length < 2) return;
        gallery.index = Math.max(0, Math.min(index, gallery.slides.length - 1));
        gallery.viewport.scrollTo({ left: gallery.slides[gallery.index].offsetLeft, behavior });
        gallery.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === gallery.index));
      };

      setGalleries.forEach((gallery) => {
        gallery.previous?.addEventListener('click', () => setGalleryIndex(gallery, gallery.index - 1));
        gallery.next?.addEventListener('click', () => setGalleryIndex(gallery, gallery.index + 1));
        gallery.viewport?.addEventListener(
          'scroll',
          () => {
            if (gallery.ticking) return;
            gallery.ticking = true;
            window.requestAnimationFrame(() => {
              const width = gallery.viewport.clientWidth || 1;
              gallery.index = Math.max(
                0,
                Math.min(Math.round(gallery.viewport.scrollLeft / width), gallery.slides.length - 1)
              );
              gallery.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === gallery.index));
              gallery.ticking = false;
            });
          },
          { passive: true }
        );
      });

      const update = () => {
        let sum = 0;
        let compareSum = 0;
        let ready = selects.length === 2;
        productCards.forEach((card, index) => {
          const select = selects[index];
          const option = select?.selectedOptions?.[0];
          if (!option || option.disabled) ready = false;
          sum += Number(option?.dataset.price || 0);
          compareSum += Number(option?.dataset.comparePrice || option?.dataset.price || 0);
          const price = card.querySelector('[data-obfp-set-price]');
          const comparePrice = card.querySelector('[data-obfp-set-compare-price]');
          if (price && option) price.textContent = option.dataset.priceFormatted || '';
          if (option?.dataset.featuredMediaId) {
            const gallery = setGalleries[index];
            const mediaIndex = gallery?.slides.findIndex(
              (slide) => String(slide.dataset.mediaId) === String(option.dataset.featuredMediaId)
            );
            if (mediaIndex >= 0 && mediaIndex !== gallery.index) setGalleryIndex(gallery, mediaIndex, 'auto');
          }
          if (comparePrice && option) {
            const itemPrice = Number(option.dataset.price || 0);
            const itemComparePrice = Number(option.dataset.comparePrice || 0);
            comparePrice.textContent = option.dataset.comparePriceFormatted || '';
            comparePrice.hidden = itemComparePrice <= itemPrice;
          }
        });
        if (total) total.textContent = formatMoney(sum);
        if (compareTotal) {
          compareTotal.textContent = formatMoney(compareSum);
          compareTotal.hidden = compareSum <= sum;
        }
        if (addButton) addButton.disabled = !ready;
        if (addLabel && addLabel.textContent !== initialLabel) addLabel.textContent = initialLabel;
        if (message) message.textContent = '';
      };

      const syncSavedFit = () => {
        let selectionChanged = false;
        productCards.forEach((card, index) => {
          const kind = card.dataset.kind;
          const select = selects[index];
          const fitNote = card.querySelector('[data-obfp-set-fit-note]');
          const sizeLabel = card.querySelector('[data-obfp-set-size-label]');
          let savedSize = '';
          try {
            savedSize =
              kind === 'top'
                ? localStorage.getItem('sizeTop') || localStorage.getItem('tops-product-size') || ''
                : localStorage.getItem('sizeBottom') || localStorage.getItem('bottoms-product-size') || '';
          } catch (error) {
            savedSize = '';
          }
          if (!savedSize || !select) return;
          const match = [...select.options].find(
            (option) =>
              !option.disabled &&
              option.dataset.options.split('||').some((value) => normalize(value) === normalize(savedSize))
          );
          if (!match) return;
          if (select.value !== match.value) {
            select.value = match.value;
            selectionChanged = true;
          }
          if (sizeLabel) sizeLabel.textContent = `His ${kind} size`;
          if (fitNote) {
            fitNote.textContent = `Size ${savedSize} selected from the saved fit. Check that the measurements are his.`;
            fitNote.hidden = false;
          }
        });
        if (selectionChanged) update();
      };

      selects.forEach((select) => select?.addEventListener('change', update));
      syncSavedFit();
      update();

      window.addEventListener('storage', syncSavedFit);
      window.addEventListener('focus', syncSavedFit);
      window.addEventListener('pageshow', syncSavedFit);

      let fitModalWasOpen = document.body.classList.contains('popup-size--opening');
      const fitModalObserver = new MutationObserver(() => {
        const fitModalIsOpen = document.body.classList.contains('popup-size--opening');
        if (fitModalWasOpen && !fitModalIsOpen) window.setTimeout(syncSavedFit, 0);
        fitModalWasOpen = fitModalIsOpen;
      });
      fitModalObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-js-element="close-popup"]')) window.setTimeout(syncSavedFit, 50);
      });

      addButton?.addEventListener('click', async () => {
        const items = selects.map((select) => ({ id: Number(select.value), quantity: 1 }));
        if (items.length !== 2 || items.some((item) => !item.id)) {
          if (message) message.textContent = root.dataset.errorLabel;
          return;
        }
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = root.dataset.addingLabel;
        if (message) message.textContent = '';
        try {
          const helper = window.Alpine?.store?.('xCartHelper');
          const payload = { items };
          if (helper) {
            payload.sections = helper.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || root.dataset.errorLabel);
          if (helper && result.sections) helper.reRenderSections(result.sections);
          const miniCart = window.Alpine?.store?.('xMiniCart');
          if (miniCart) miniCart.openCart();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          if (addLabel) addLabel.textContent = root.dataset.addedLabel;
          if (message) message.textContent = root.dataset.addedLabel;
        } catch (error) {
          if (addLabel) addLabel.textContent = initialLabel;
          if (message) message.textContent = error.message || root.dataset.errorLabel;
        } finally {
          addButton.disabled = false;
        }
      });
    });
  })();

  (() => {
    const bindGallery = (viewport, slides, dots) => {
      if (!viewport || slides.length < 2 || viewport.dataset.obfpSnapReady) return;
      viewport.dataset.obfpSnapReady = 'true';
      let frame;
      let settleTimer;

      const closestIndex = () =>
        slides.reduce(
          (best, slide, index) =>
            Math.abs(viewport.scrollLeft - slide.offsetLeft) < Math.abs(viewport.scrollLeft - slides[best].offsetLeft)
              ? index
              : best,
          0
        );

      const updateDots = () => {
        const active = closestIndex();
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      };

      const settle = () => {
        const active = closestIndex();
        const target = slides[active].offsetLeft;
        if (Math.abs(viewport.scrollLeft - target) > 1) viewport.scrollTo({ left: target, behavior: 'auto' });
        updateDots();
      };

      viewport.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          clearTimeout(settleTimer);
          frame = requestAnimationFrame(updateDots);
          settleTimer = window.setTimeout(settle, 120);
        },
        { passive: true }
      );

      updateDots();
    };

    document.querySelectorAll('[data-obfp-section]').forEach((root) => {
      if (root.hasAttribute('data-obfp-inline-colours') && root.querySelector('.obfp__linked-swatches')) return;
      bindGallery(
        root.querySelector('[data-obfp-viewport]'),
        [...root.querySelectorAll('[data-obfp-slide]')],
        [...root.querySelectorAll('[data-obfp-dot]')]
      );
    });

    document.querySelectorAll('[data-obfp-matching] [data-obfp-set-product]').forEach((card) => {
      bindGallery(
        card.querySelector('[data-obfp-set-viewport]'),
        [...card.querySelectorAll('[data-obfp-set-slide]')],
        [...card.querySelectorAll('[data-obfp-set-dot]')]
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-featured-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-obfp-section]');
    roots.forEach((root) => {
      if (root.dataset.obfpReady) return;
      root.dataset.obfpReady = 'true';
      const variantsNode = root.querySelector('[data-obfp-variants]'),
        form = root.querySelector('[data-obfp-form]');
      if (!variantsNode || !form) return;
      const variants = JSON.parse(variantsNode.textContent),
        variantInput = form.querySelector('[data-obfp-variant-id]'),
        inputs = [...form.querySelectorAll('[data-obfp-option-input]')],
        price = root.querySelector('[data-obfp-price]'),
        compare = root.querySelector('[data-obfp-compare]'),
        button = root.querySelector('[data-obfp-submit]'),
        buttonLabel = root.querySelector('[data-obfp-submit-label]'),
        buttonPrice = root.querySelector('[data-obfp-button-price]'),
        message = root.querySelector('[data-obfp-message]'),
        productLink = root.querySelector('[data-obfp-product-link]'),
        sticky = root.querySelector('[data-obfp-sticky]'),
        stickyButton = root.querySelector('[data-obfp-sticky-button]'),
        stickyLabel = root.querySelector('[data-obfp-sticky-label]'),
        stickyPrice = root.querySelector('[data-obfp-sticky-price]'),
        stickyVariant = root.querySelector('[data-obfp-sticky-variant]'),
        viewport = root.querySelector('[data-obfp-viewport]'),
        slides = [...root.querySelectorAll('[data-obfp-slide]')],
        thumbs = [...root.querySelectorAll('[data-obfp-thumbnail]')],
        current = root.querySelector('[data-obfp-current]');
      let activeVariant = variants.find((v) => String(v.id) === String(variantInput.value)) || variants[0],
        activeSlide = 0,
        buttonInView = true;
      const inlineColours = root.hasAttribute('data-obfp-inline-colours') && Boolean(root.querySelector('.obfp__linked-swatches'));
      let colourLoading = false;
      let cartAdding = false;
      const labels = {
          add: root.dataset.addLabel,
          sold: root.dataset.soldLabel,
          adding: root.dataset.addingLabel,
          added: root.dataset.addedLabel,
          error: root.dataset.errorLabel,
          fitSelected: root.dataset.fitSelected,
          fitUnavailable: root.dataset.fitUnavailable,
          fitRecommendation: root.dataset.fitRecommendation,
        },
        withSize = (template, size) => template.replace('[size]', size),
        selectedOptions = () => {
          const groups = [...form.querySelectorAll('[data-obfp-option]')];
          return groups
            .map((group) => group.querySelector('[data-obfp-option-input]:checked')?.value)
            .filter((value) => value !== undefined);
        },
        findVariant = () => {
          if (!form.querySelector('[data-obfp-option]')) {
            return variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants.find((variant) => variant.available) || variants[0];
          }
          const selected = selectedOptions();
          return variants.find(
            (variant) =>
              variant.options.length === selected.length &&
              variant.options.every((value, index) => value === selected[index])
          );
        },
        showSlide = (index) => {
          if (!viewport || !slides.length) return;
          activeSlide = Math.max(0, Math.min(index, slides.length - 1));
          slides[activeSlide].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === activeSlide);
            thumb.setAttribute('aria-pressed', i === activeSlide ? 'true' : 'false');
          });
          if (current) current.textContent = String(activeSlide + 1);
          if (inlineColours) root.querySelectorAll('[data-obfp-dot]').forEach((dot, index) =>
            dot.classList.toggle('is-active', index === activeSlide));
        },
        showMedia = (id) => {
          if (!id) return;
          const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(id));
          if (index >= 0) showSlide(index);
        },
        setAvailability = () => {
          const selected = selectedOptions();
          inputs.forEach((input) => {
            const position = Number(input.dataset.optionPosition) - 1,
              candidate = [...selected];
            candidate[position] = input.value;
            const available = variants.some(
              (variant) =>
                variant.available &&
                variant.options.every((value, index) => candidate[index] === undefined || value === candidate[index])
            );
            input.disabled = !available;
            input.closest('label')?.classList.toggle('is-unavailable', !available);
          });
        },
        update = () => {
          if (inlineColours && (colourLoading || cartAdding)) return;
          const variant = findVariant();
          activeVariant = variant || null;
          root.dataset.soldOut = String(!variant?.available);
          setAvailability();
          form.querySelectorAll('[data-obfp-option]').forEach((group) => {
            const selectedLabel = group.querySelector('[data-obfp-option-value]');
            if (selectedLabel) selectedLabel.textContent = group.querySelector('input:checked')?.value || '';
          });
          if (!variant) {
            variantInput.value = '';
            button.disabled = true;
            if (stickyButton) stickyButton.disabled = true;
            message.textContent = labels.sold;
            if (inlineColours) {
              buttonLabel.textContent = root.dataset.chooseLabel;
              buttonPrice.textContent = '';
              if (stickyLabel) stickyLabel.textContent = root.dataset.chooseLabel;
              if (stickyPrice) stickyPrice.textContent = '';
              if (stickyVariant) stickyVariant.textContent = '';
              message.textContent = root.dataset.chooseLabel;
            }
            return;
          }
          variantInput.value = variant.id;
          price.textContent = variant.price_formatted;
          price.classList.toggle('is-sale', variant.compare_at_price > variant.price);
          if (variant.compare_at_price > variant.price) {
            compare.textContent = variant.compare_at_price_formatted;
            compare.classList.remove('is-hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('is-hidden');
          }
          const available = variant.available;
          if (inlineColours && fitMessage) {
            const sizeGroup = [...form.querySelectorAll('[data-obfp-option]')].find((group) => group.dataset.optionName.toLowerCase().includes('size'));
            const size = sizeGroup?.querySelector('input:checked')?.value;
            if (size) fitMessage.textContent = withSize(available ? labels.fitSelected : labels.fitUnavailable, size);
          }
          button.disabled = !available;
          buttonLabel.textContent = available ? labels.add : labels.sold;
          buttonPrice.textContent = available ? variant.price_formatted : '';
          if (stickyButton) stickyButton.disabled = !available;
          if (stickyLabel) stickyLabel.textContent = available ? labels.add : labels.sold;
          if (stickyPrice) stickyPrice.textContent = available ? variant.price_formatted : '';
          if (stickyVariant) stickyVariant.textContent = variant.title;
          if (productLink) productLink.href = `${productLink.href.split('?')[0]}?variant=${variant.id}`;
          message.textContent = '';
          showMedia(variant.featured_media_id);
        };
      inputs.forEach((input) => input.addEventListener('change', update));
      if (inlineColours) {
        const swatchWrap = root.querySelector('.obfp__linked-swatches');
        const swatches = [...swatchWrap.querySelectorAll('a[data-swatch-name]')];
        let currentSwatch = swatches.find((swatch) => swatch.classList.contains('is-active'));
        let requestNumber = 0;
        let controller;
        const optionKind = (name) => {
          const normalized = name.trim().toLowerCase();
          return normalized.match(/\(([^()]*)\)\s*$/)?.[1] || normalized;
        };
        const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: root.dataset.currency, currencyDisplay: 'narrowSymbol',
        }).format(cents / 100);
        const setSwatches = (selected) => {
          currentSwatch = selected;
          swatches.forEach((swatch) => {
            const active = swatch === selected;
            swatch.classList.toggle('is-active', active);
            swatch.setAttribute('aria-pressed', String(active));
          });
          swatchWrap.querySelectorAll('[data-swatch-group]').forEach((group) => {
            const active = group.querySelector('.is-active');
            group.dataset.defaultName = active?.dataset.swatchName || '';
            const label = group.closest('.x-swatch-section').querySelector('[data-swatch-label]');
            if (label) label.textContent = group.dataset.defaultName;
          });
        };
        swatchWrap.querySelectorAll('[data-swatch-label]').forEach((label) => {
          new MutationObserver(() => {
            const expected = label.closest('.x-swatch-section').contains(currentSwatch) ? currentSwatch.dataset.swatchName : '';
            if (label.textContent !== expected) label.textContent = expected;
          }).observe(label, { childList: true, characterData: true, subtree: true });
        });
        const setBusy = (busy) => {
          colourLoading = busy;
          root.setAttribute('aria-busy', String(busy));
          form.querySelector('.obfp__options')?.toggleAttribute('inert', busy);
          if (busy) {
            button.disabled = true;
            if (stickyButton) stickyButton.disabled = true;
            message.textContent = root.dataset.colourLoading;
          }
        };
        swatches.forEach((swatch) => {
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('aria-pressed', String(swatch.classList.contains('is-active')));
          swatch.addEventListener('keydown', (event) => {
            if (event.key === ' ') { event.preventDefault(); swatch.click(); }
          });
        });
        swatchWrap.addEventListener('click', async (event) => {
          const swatch = event.target.closest('a[data-swatch-name]');
          if (!swatch || !swatchWrap.contains(swatch)) return;
          event.preventDefault();
          if (cartAdding) return;
          const request = ++requestNumber;
          controller?.abort();
          controller = new AbortController();
          const requestController = controller;
          const timeout = setTimeout(() => requestController.abort(), 15000);
          const saved = [...form.querySelectorAll('[data-obfp-option]')].map((group) =>
            group.querySelector('input:checked')?.value);
          setBusy(true);
          try {
            const url = new URL(swatch.href, location.origin);
            if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error();
            url.pathname += '.js';
            url.search = '';
            const response = await fetch(url, { signal: requestController.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error();
            const product = await response.json();
            if (!product.id || !product.variants?.length || !product.images?.length) throw new Error();
            if (request !== requestNumber) return;
            const groups = [...form.querySelectorAll('[data-obfp-option]')];
            const defaultOnly = product.variants.length === 1 && product.options.length === 1 && product.options[0].name === 'Title';
            if (!(defaultOnly && groups.length === 0) && (product.options.length !== groups.length || product.options.some((option, index) =>
              optionKind(option.name) !== optionKind(groups[index].dataset.optionName)))) throw new Error();
            const nextVariants = product.variants.map((variant) => ({
              ...variant,
              price_formatted: money(variant.price),
              compare_at_price_formatted: money(variant.compare_at_price || 0),
              featured_media_id: variant.featured_media?.id || 0,
            }));
            const selected = saved;
            const sizeValue = (value) => String(value ?? '').trim().replace(/^size\s*/i, '').replace(/^(-?\d+)\s*\([^)]*\)$/, '$1');
            const preserved = nextVariants.find((variant) =>
              variant.options.every((value, index) => product.options[index].name.toLowerCase().includes('size')
                ? sizeValue(value) === sizeValue(selected[index]) : value === selected[index]));
            const imageMedia = (product.media || []).filter((media) => media.media_type === 'image');
            const images = product.images.slice(0, Number(root.dataset.galleryLimit) || 1);
            const imageUrl = (source, width) => {
              const url = new URL(source, location.origin); url.searchParams.set('width', width); return url.href;
            };
            const image = new Image();
            image.src = imageUrl(images[0], 960);
            await Promise.race([image.decode(), new Promise((_, reject) => setTimeout(reject, 10000))]);
            if (request !== requestNumber) return;
            const newSlides = images.map((source, index) => {
              const slide = document.createElement('div');
              slide.className = 'obfp__slide'; slide.dataset.obfpSlide = '';
              slide.dataset.mediaId = imageMedia[index]?.id || '';
              slide.setAttribute('aria-label', `${index + 1} / ${images.length}`);
              const img = document.createElement('img');
              img.className = 'obfp__image'; img.alt = `${product.title} — ${index + 1}`;
              img.src = imageUrl(source, 1600);
              img.srcset = [480,720,960,1200,1600].map((width) => `${imageUrl(source,width)} ${width}w`).join(', ');
              img.sizes = '(min-width: 990px) 52vw, 100vw'; img.loading = index ? 'lazy' : 'eager';
              img.width = imageMedia[index]?.preview_image?.width || image.naturalWidth;
              img.height = imageMedia[index]?.preview_image?.height || image.naturalHeight;
              slide.append(img); return slide;
            });
            variants.splice(0, variants.length, ...nextVariants);
            variantsNode.textContent = JSON.stringify(nextVariants);
            const displayVariant = preserved || nextVariants[0];
            price.textContent = displayVariant.price_formatted;
            price.classList.toggle('is-sale', displayVariant.compare_at_price > displayVariant.price);
            compare.textContent = displayVariant.compare_at_price > displayVariant.price ? displayVariant.compare_at_price_formatted : '';
            compare.classList.toggle('is-hidden', !(displayVariant.compare_at_price > displayVariant.price));
            root.dataset.productId = product.id;
            if (defaultOnly) variantInput.value = displayVariant.id;
            if (root.dataset.productTitleSource === 'product_title') {
              const title = root.querySelector('.obfp__product-title');
              const stickyTitle = sticky?.querySelector('strong');
              if (title) title.textContent = product.title;
              if (stickyTitle) stickyTitle.textContent = product.title;
            }
            const productId = form.querySelector('[name="product-id"]');
            if (productId) productId.value = product.id;
            if (productLink) productLink.href = swatch.href;
            groups.forEach((group, index) => {
              group.dataset.optionName = product.options[index].name;
              const legend = group.querySelector('legend');
              if (legend?.firstChild?.nodeType === Node.TEXT_NODE) {
                legend.firstChild.textContent = product.options[index].name + (legend.querySelector('[data-obfp-option-value]') ? ': ' : '');
              }
              const values = [...new Set(nextVariants.map((variant) => variant.options[index]))];
              const container = group.querySelector('.obfp__option-values');
              container.replaceChildren(...values.map((value) => {
                const label = document.createElement('label'); label.className = 'obfp__option-label';
                const input = document.createElement('input'); input.type = 'radio';
                input.name = `obfp-option-${root.dataset.obfpSection}-${index + 1}`;
                input.value = value; input.setAttribute('aria-label', value);
                input.dataset.obfpOptionInput = ''; input.dataset.optionPosition = index + 1;
                input.checked = Boolean(preserved && preserved.options[index] === value);
                input.addEventListener('change', update);
                const text = document.createElement('span'); text.textContent = value;
                label.append(input, text); return label;
              }));
            });
            inputs.splice(0, inputs.length, ...form.querySelectorAll('[data-obfp-option-input]'));
            viewport.replaceChildren(...newSlides); viewport.scrollTo({ left: 0, behavior: 'instant' });
            slides.splice(0, slides.length, ...newSlides); activeSlide = 0;
            const thumbnailWrap = root.querySelector('.obfp__thumbnails');
            if (thumbnailWrap) {
              const newThumbs = newSlides.map((slide, index) => {
                const thumb = document.createElement('button'); thumb.type = 'button';
                thumb.className = `obfp__thumbnail${index ? '' : ' is-active'}`;
                thumb.dataset.obfpThumbnail = index; thumb.setAttribute('aria-label', slide.getAttribute('aria-label'));
                thumb.setAttribute('aria-pressed', String(index === 0));
                const img = slide.querySelector('img').cloneNode(); img.className = 'obfp__thumbnail-image';
                img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = imageUrl(images[index],180);
                thumb.append(img); thumb.addEventListener('click', () => showSlide(index)); return thumb;
              });
              thumbnailWrap.replaceChildren(...newThumbs); thumbs.splice(0, thumbs.length, ...newThumbs);
            }
            const dots = root.querySelector('.obfp__gallery-dots');
            if (dots) dots.replaceChildren(...images.map((_, index) => {
              const dot = document.createElement('span'); dot.dataset.obfpDot = index;
              dot.classList.toggle('is-active', index === 0); return dot;
            }));
            if (current) current.parentElement.replaceChildren(current, document.createTextNode(` / ${images.length}`));
            setSwatches(swatch);
            setBusy(false); update();
            if (!preserved && fitMessage) fitMessage.textContent = root.dataset.chooseLabel;
          } catch (error) {
            if (request !== requestNumber) return;
            setBusy(false); update();
            message.textContent = root.dataset.colourError;
            setSwatches(swatches.find((item) => item.classList.contains('is-active')));
          } finally {
            clearTimeout(timeout);
            if (request === requestNumber && colourLoading) setBusy(false);
          }
        });
      }
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.obfpThumbnail))));
      root.querySelector('[data-obfp-previous]')?.addEventListener('click', () => showSlide(activeSlide - 1));
      root.querySelector('[data-obfp-next]')?.addEventListener('click', () => showSlide(activeSlide + 1));
      if (viewport) {
        let ticking = false;
        viewport.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              const width = viewport.clientWidth || 1,
                position = Math.round(viewport.scrollLeft / width);
              if (position !== activeSlide) {
                activeSlide = position;
                thumbs.forEach((thumb, i) => {
                  thumb.classList.toggle('is-active', i === activeSlide);
                  thumb.setAttribute('aria-pressed', i === activeSlide ? 'true' : 'false');
                });
                if (current) current.textContent = String(activeSlide + 1);
                if (inlineColours) root.querySelectorAll('[data-obfp-dot]').forEach((dot, index) =>
                  dot.classList.toggle('is-active', index === activeSlide));
              }
              ticking = false;
            });
          },
          { passive: true }
        );
      }
      const emailCodeLink = root.querySelector('[data-obfp-email-code]');
      emailCodeLink?.addEventListener('click', (event) => {
        event.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'W5sKSn']);
      });
      const fit = root.querySelector('[data-obfp-fit]'),
        openFit = root.querySelector('[data-obfp-open-fit]'),
        height = root.querySelector('[data-obfp-height]'),
        weight = root.querySelector('[data-obfp-weight]'),
        heightOutput = root.querySelector('[data-obfp-height-output]'),
        weightOutput = root.querySelector('[data-obfp-weight-output]'),
        fitSize = root.querySelector('[data-obfp-fit-size]'),
        fitMessage = root.querySelector('[data-obfp-fit-message]'),
        matrix = [
          { max: 179, s: ['-2', '-2', '-2', '-1', '-1', '-1', '-1'] },
          { max: 189, s: ['-1', '-1', '-1', '-1', '-1', '-1', '-1'] },
          { max: 199, s: ['0', '0', '-1', '-1', '-1', '-1', '-1'] },
          { max: 209, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 219, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 229, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 239, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 249, s: ['0', '0', '0', '0', '0', '0', '0'] },
          { max: 259, s: ['1', '1', '1', '0', '0', '0', '0'] },
          { max: 269, s: ['1', '1', '1', '1', '1', '1', '1'] },
          { max: 279, s: ['2', '1', '1', '1', '1', '1', '1'] },
          { max: 289, s: ['2', '2', '1', '1', '1', '1', '1'] },
          { max: 299, s: ['2', '2', '1', '1', '1', '1', '1'] },
          { max: 309, s: ['2', '2', '1', '1', '1', '1', '1'] },
          { max: 319, s: ['3', '3', '2', '2', '2', '1', '1'] },
          { max: 329, s: ['3', '3', '2', '2', '2', '2', '2'] },
          { max: 339, s: ['3', '3', '3', '3', '3', '3', '3'] },
          { max: 349, s: ['4', '4', '3', '3', '3', '3', '3'] },
          { max: 359, s: ['4', '4', '3', '3', '3', '3', '3'] },
          { max: 369, s: ['4', '4', '4', '4', '4', '4', '4'] },
          { max: 379, s: ['4', '4', '4', '4', '4', '4', '4'] },
          { max: 389, s: ['5', '5', '4', '4', '4', '3', '3'] },
          { max: 399, s: ['5', '5', '5', '4', '4', '4', '4'] },
          { max: 409, s: ['5', '5', '5', '5', '5', '5', '5'] },
          { max: 419, s: ['5', '5', '5', '5', '5', '5', '5'] },
          { max: 429, s: ['5', '5', '5', '5', '5', '5', '5'] },
          { max: 439, s: ['6', '5', '5', '5', '5', '5', '5'] },
          { max: 449, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 459, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 469, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 479, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 489, s: ['6', '6', '6', '6', '6', '6', '6'] },
          { max: 499, s: ['7', '7', '7', '7', '7', '7', '7'] },
          { max: Infinity, s: ['7', '7', '7', '7', '7', '7', '7'] },
        ],
        heightColumn = (value) =>
          value <= 68 ? 0 : value <= 71 ? 1 : value <= 74 ? 2 : value <= 77 ? 3 : value <= 80 ? 4 : value <= 83 ? 5 : 6,
        normalize = (value) =>
          String(value)
            .toLowerCase()
            .replace(/^size\s*/, '')
            .trim(),
        recommend = () => {
          if (inlineColours && (colourLoading || cartAdding)) return;
          if (!height || !weight) return;
          const inches = Number(height.value),
            pounds = Number(weight.value),
            row = matrix.find((range) => pounds <= range.max) || matrix[matrix.length - 1],
            size = row.s[heightColumn(inches)];
          heightOutput.textContent = `${Math.floor(inches / 12)}'${inches % 12}\"`;
          weightOutput.textContent = pounds >= 500 ? '500 lb+' : `${pounds} lb`;
          fitSize.textContent = size;
          const sizeGroup = [...form.querySelectorAll('[data-obfp-option]')].find((group) =>
            group.dataset.optionName.toLowerCase().includes('size')
          );
          const sizeInput = sizeGroup
            ? [...sizeGroup.querySelectorAll('[data-obfp-option-input]')].find(
                (input) => normalize(input.value) === normalize(size)
              )
            : null;
          if (sizeInput && !sizeInput.disabled) {
            if (!sizeInput.checked) {
              sizeInput.checked = true;
              sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            fitMessage.textContent = withSize(labels.fitSelected, size);
          } else if (sizeInput) {
            fitMessage.textContent = withSize(labels.fitUnavailable, size);
          } else {
            fitMessage.textContent = withSize(labels.fitRecommendation, size);
          }
        };
      openFit?.addEventListener('click', () => {
        fit.open = !fit.open;
        openFit.setAttribute('aria-expanded', fit.open ? 'true' : 'false');
        if (fit.open) fit.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      fit?.addEventListener('toggle', () => openFit?.setAttribute('aria-expanded', fit.open ? 'true' : 'false'));
      height?.addEventListener('input', recommend);
      weight?.addEventListener('input', recommend);
      recommend();

      /*
        The theme's own fit picker works out a size and publishes it; the
        product page preselects from that, and so should this section. It
        cannot share the product page's markup — that machinery keys off
        .js-option-size and a variant id, and these are plain radios — so it
        listens for the same event and matches on the value it already knows
        how to compare.
      */
      const fitScope = root.dataset.obfpFitScope === 'bottom' ? 'bottom' : 'top';
      const applyStoredFit = (profile) => {
        if (inlineColours && (colourLoading || cartAdding)) return;
        if (!profile || !profile.captured) return;
        const wanted = profile[fitScope];
        if (!wanted) return;
        const sizeGroup = [...form.querySelectorAll('[data-obfp-option]')].find((group) =>
          group.dataset.optionName.toLowerCase().includes('size')
        );
        if (!sizeGroup) return;
        const input = [...sizeGroup.querySelectorAll('[data-obfp-option-input]')].find(
          (candidate) => normalize(candidate.value) === normalize(wanted)
        );
        if (!input || input.disabled || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const readFitProfile = () => window.OneBoneFit && window.OneBoneFit.getProfile();
      document.addEventListener('onebone:fit:change', (event) => applyStoredFit(event.detail));
      // fit-finder.js is a separate bundle and may load after this one, so take
      // whichever of the two arrives second.
      document.addEventListener('onebone:fit:ready', () => applyStoredFit(readFitProfile()));
      applyStoredFit(readFitProfile());
      form.addEventListener('submit', async (event) => {
        if (inlineColours && (colourLoading || cartAdding)) { event.preventDefault(); return; }
        if (root.dataset.cartEnabled === 'false') { event.preventDefault(); return; }
        if (!activeVariant || !activeVariant.available) {
          event.preventDefault();
          message.textContent = labels.sold;
          form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();
          return;
        }
        if (!window.fetch) return;
        event.preventDefault();
        button.disabled = true;
        if (inlineColours) cartAdding = true;
        message.textContent = labels.adding;
        const data = new FormData(form);
        try {
          const helper = window.Alpine?.store?.('xCartHelper');
          if (helper) {
            data.append(
              'sections',
              helper.getSectionsToRender().map((section) => section.id)
            );
            data.append('sections_url', window.location.pathname);
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: data,
            }),
            result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || labels.error);
          if (helper && result.sections) helper.reRenderSections(result.sections);
          const notice = window.Alpine?.store?.('xCartNoti');
          if (notice?.enable) notice.setItem(result);
          const miniCart = window.Alpine?.store?.('xMiniCart');
          if (miniCart && !notice?.enable) miniCart.openCart();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          message.textContent = labels.added;
        } catch (error) {
          message.textContent = error.message || labels.error;
        } finally {
          if (inlineColours) cartAdding = false;
          button.disabled = !activeVariant?.available;
        }
      });
      stickyButton?.addEventListener('click', () => {
        if (button.disabled) {
          form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        button.click();
      });
      if (sticky && button) {
        const landingAnchor = root.querySelector('[data-obfp-anchor]');
        let anchorOffset = 12;
        const measureAnchorOffset = () => {
          const header = document.getElementById('sticky-header-content');
          anchorOffset = (header ? header.getBoundingClientRect().height : 0) + 12;
          if (landingAnchor) landingAnchor.style.scrollMarginTop = `${anchorOffset}px`;
        };
        if (landingAnchor) measureAnchorOffset();
        const observer = new IntersectionObserver(
            (entries) => {
              buttonInView = entries[0].isIntersecting;
              updateSticky();
            },
            { threshold: 0.1 }
          ),
          updateSticky = () => {
            const rect = root.getBoundingClientRect(),
              sectionVisible = rect.top < window.innerHeight && rect.bottom > 0,
              anchorReached = landingAnchor
                ? landingAnchor.getBoundingClientRect().top <= anchorOffset + 2
                : rect.top < 0,
              show = sectionVisible && !buttonInView && anchorReached;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          };
        observer.observe(button);
        window.addEventListener('scroll', updateSticky, { passive: true });
        if (landingAnchor) {
          window.addEventListener('resize', () => {
            measureAnchorOffset();
            updateSticky();
          }, { passive: true });
        }
      }
      update();
    });
  })();
  (() => {
    document.querySelectorAll('[data-obfp-matching]').forEach((root) => {
      if (root.dataset.obfpMatchingReady) return;
      root.dataset.obfpMatchingReady = 'true';

      const productCards = [...root.querySelectorAll('[data-obfp-set-product]')];
      const selects = productCards.map((card) => card.querySelector('[data-obfp-set-select]'));
      const addButton = root.querySelector('[data-obfp-set-add]');
      const addLabel = root.querySelector('[data-obfp-set-add-label]');
      const total = root.querySelector('[data-obfp-set-total]');
      const compareTotal = root.querySelector('[data-obfp-set-compare-total]');
      const message = root.querySelector('[data-obfp-set-message]');
      const initialLabel = addLabel?.textContent.trim() || 'Add the set to bag';
      const normalize = (value) =>
        String(value || '')
          .toLowerCase()
          .replace(/^size\s*/, '')
          .trim();
      const formatMoney = (cents) => {
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'CAD' }).format(
          cents / 100
        );
      };

      const setGalleries = productCards.map((card) => {
        const viewport = card.querySelector('[data-obfp-set-viewport]');
        const slides = [...card.querySelectorAll('[data-obfp-set-slide]')];
        const dots = [...card.querySelectorAll('[data-obfp-set-dot]')];
        const previous = card.querySelector('[data-obfp-set-previous]');
        const next = card.querySelector('[data-obfp-set-next]');
        return { viewport, slides, dots, previous, next, index: 0, ticking: false };
      });

      const setGalleryIndex = (gallery, index, behavior = 'smooth') => {
        if (!gallery?.viewport || gallery.slides.length < 2) return;
        gallery.index = Math.max(0, Math.min(index, gallery.slides.length - 1));
        gallery.viewport.scrollTo({ left: gallery.slides[gallery.index].offsetLeft, behavior });
        gallery.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === gallery.index));
      };

      setGalleries.forEach((gallery) => {
        gallery.previous?.addEventListener('click', () => setGalleryIndex(gallery, gallery.index - 1));
        gallery.next?.addEventListener('click', () => setGalleryIndex(gallery, gallery.index + 1));
        gallery.viewport?.addEventListener(
          'scroll',
          () => {
            if (gallery.ticking) return;
            gallery.ticking = true;
            window.requestAnimationFrame(() => {
              const width = gallery.viewport.clientWidth || 1;
              gallery.index = Math.max(
                0,
                Math.min(Math.round(gallery.viewport.scrollLeft / width), gallery.slides.length - 1)
              );
              gallery.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === gallery.index));
              gallery.ticking = false;
            });
          },
          { passive: true }
        );
      });

      const update = () => {
        let sum = 0;
        let compareSum = 0;
        let ready = selects.length === 2;
        productCards.forEach((card, index) => {
          const select = selects[index];
          const option = select?.selectedOptions?.[0];
          if (!option || option.disabled) ready = false;
          sum += Number(option?.dataset.price || 0);
          compareSum += Number(option?.dataset.comparePrice || option?.dataset.price || 0);
          const price = card.querySelector('[data-obfp-set-price]');
          const comparePrice = card.querySelector('[data-obfp-set-compare-price]');
          if (price && option) price.textContent = option.dataset.priceFormatted || '';
          if (option?.dataset.featuredMediaId) {
            const gallery = setGalleries[index];
            const mediaIndex = gallery?.slides.findIndex(
              (slide) => String(slide.dataset.mediaId) === String(option.dataset.featuredMediaId)
            );
            if (mediaIndex >= 0 && mediaIndex !== gallery.index) setGalleryIndex(gallery, mediaIndex, 'auto');
          }
          if (comparePrice && option) {
            const itemPrice = Number(option.dataset.price || 0);
            const itemComparePrice = Number(option.dataset.comparePrice || 0);
            comparePrice.textContent = option.dataset.comparePriceFormatted || '';
            comparePrice.hidden = itemComparePrice <= itemPrice;
          }
        });
        if (total) total.textContent = formatMoney(sum);
        if (compareTotal) {
          compareTotal.textContent = formatMoney(compareSum);
          compareTotal.hidden = compareSum <= sum;
        }
        if (addButton) addButton.disabled = !ready;
        if (addLabel && addLabel.textContent !== initialLabel) addLabel.textContent = initialLabel;
        if (message) message.textContent = '';
      };

      const syncSavedFit = () => {
        let selectionChanged = false;
        productCards.forEach((card, index) => {
          const kind = card.dataset.kind;
          const select = selects[index];
          const fitNote = card.querySelector('[data-obfp-set-fit-note]');
          const sizeLabel = card.querySelector('[data-obfp-set-size-label]');
          let savedSize = '';
          try {
            savedSize =
              kind === 'top'
                ? localStorage.getItem('sizeTop') || localStorage.getItem('tops-product-size') || ''
                : localStorage.getItem('sizeBottom') || localStorage.getItem('bottoms-product-size') || '';
          } catch (error) {
            savedSize = '';
          }
          if (!savedSize || !select) return;
          const match = [...select.options].find(
            (option) =>
              !option.disabled &&
              option.dataset.options.split('||').some((value) => normalize(value) === normalize(savedSize))
          );
          if (!match) return;
          if (select.value !== match.value) {
            select.value = match.value;
            selectionChanged = true;
          }
          if (sizeLabel) sizeLabel.textContent = `Your ${kind} size`;
          if (fitNote) {
            fitNote.textContent = `Size ${savedSize} selected from your saved fit.`;
            fitNote.hidden = false;
          }
        });
        if (selectionChanged) update();
      };

      selects.forEach((select) => select?.addEventListener('change', update));
      syncSavedFit();
      update();

      window.addEventListener('storage', syncSavedFit);
      window.addEventListener('focus', syncSavedFit);
      window.addEventListener('pageshow', syncSavedFit);

      let fitModalWasOpen = document.body.classList.contains('popup-size--opening');
      const fitModalObserver = new MutationObserver(() => {
        const fitModalIsOpen = document.body.classList.contains('popup-size--opening');
        if (fitModalWasOpen && !fitModalIsOpen) window.setTimeout(syncSavedFit, 0);
        fitModalWasOpen = fitModalIsOpen;
      });
      fitModalObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-js-element="close-popup"]')) window.setTimeout(syncSavedFit, 50);
      });

      addButton?.addEventListener('click', async () => {
        const items = selects.map((select) => ({ id: Number(select.value), quantity: 1 }));
        if (items.length !== 2 || items.some((item) => !item.id)) {
          if (message) message.textContent = root.dataset.errorLabel;
          return;
        }
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = root.dataset.addingLabel;
        if (message) message.textContent = '';
        try {
          const helper = window.Alpine?.store?.('xCartHelper');
          const payload = { items };
          if (helper) {
            payload.sections = helper.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || root.dataset.errorLabel);
          if (helper && result.sections) helper.reRenderSections(result.sections);
          const miniCart = window.Alpine?.store?.('xMiniCart');
          if (miniCart) miniCart.openCart();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          if (addLabel) addLabel.textContent = root.dataset.addedLabel;
          if (message) message.textContent = root.dataset.addedLabel;
        } catch (error) {
          if (addLabel) addLabel.textContent = initialLabel;
          if (message) message.textContent = error.message || root.dataset.errorLabel;
        } finally {
          addButton.disabled = false;
        }
      });
    });
  })();

  (() => {
    const bindGallery = (viewport, slides, dots) => {
      if (!viewport || slides.length < 2 || viewport.dataset.obfpSnapReady) return;
      viewport.dataset.obfpSnapReady = 'true';
      let frame;
      let settleTimer;

      const closestIndex = () =>
        slides.reduce(
          (best, slide, index) =>
            Math.abs(viewport.scrollLeft - slide.offsetLeft) < Math.abs(viewport.scrollLeft - slides[best].offsetLeft)
              ? index
              : best,
          0
        );

      const updateDots = () => {
        const active = closestIndex();
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      };

      const settle = () => {
        const active = closestIndex();
        const target = slides[active].offsetLeft;
        if (Math.abs(viewport.scrollLeft - target) > 1) viewport.scrollTo({ left: target, behavior: 'auto' });
        updateDots();
      };

      viewport.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          clearTimeout(settleTimer);
          frame = requestAnimationFrame(updateDots);
          settleTimer = window.setTimeout(settle, 120);
        },
        { passive: true }
      );

      updateDots();
    };

    document.querySelectorAll('[data-obfp-section]').forEach((root) => {
      if (root.hasAttribute('data-obfp-inline-colours') && root.querySelector('.obfp__linked-swatches')) return;
      bindGallery(
        root.querySelector('[data-obfp-viewport]'),
        [...root.querySelectorAll('[data-obfp-slide]')],
        [...root.querySelectorAll('[data-obfp-dot]')]
      );
    });

    document.querySelectorAll('[data-obfp-matching] [data-obfp-set-product]').forEach((card) => {
      bindGallery(
        card.querySelector('[data-obfp-set-viewport]'),
        [...card.querySelectorAll('[data-obfp-set-slide]')],
        [...card.querySelectorAll('[data-obfp-set-dot]')]
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-fit-lock-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const matrix = [
      { max: 179, s: ['-2', '-2', '-2', '-1', '-1', '-1', '-1'] },
      { max: 189, s: ['-1', '-1', '-1', '-1', '-1', '-1', '-1'] },
      { max: 199, s: ['0', '0', '-1', '-1', '-1', '-1', '-1'] },
      { max: 209, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 219, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 229, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 239, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 249, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 259, s: ['1', '1', '1', '0', '0', '0', '0'] },
      { max: 269, s: ['1', '1', '1', '1', '1', '1', '1'] },
      { max: 279, s: ['2', '1', '1', '1', '1', '1', '1'] },
      { max: 289, s: ['2', '2', '1', '1', '1', '1', '1'] },
      { max: 299, s: ['2', '2', '1', '1', '1', '1', '1'] },
      { max: 309, s: ['2', '2', '1', '1', '1', '1', '1'] },
      { max: 319, s: ['3', '3', '2', '2', '2', '1', '1'] },
      { max: 329, s: ['3', '3', '2', '2', '2', '2', '2'] },
      { max: 339, s: ['3', '3', '3', '3', '3', '3', '3'] },
      { max: 349, s: ['4', '4', '3', '3', '3', '3', '3'] },
      { max: 359, s: ['4', '4', '3', '3', '3', '3', '3'] },
      { max: 369, s: ['4', '4', '4', '4', '4', '4', '4'] },
      { max: 379, s: ['4', '4', '4', '4', '4', '4', '4'] },
      { max: 389, s: ['5', '5', '4', '4', '4', '3', '3'] },
      { max: 399, s: ['5', '5', '5', '4', '4', '4', '4'] },
      { max: 409, s: ['5', '5', '5', '5', '5', '5', '5'] },
      { max: 419, s: ['5', '5', '5', '5', '5', '5', '5'] },
      { max: 429, s: ['5', '5', '5', '5', '5', '5', '5'] },
      { max: 439, s: ['6', '5', '5', '5', '5', '5', '5'] },
      { max: 449, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 459, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 469, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 479, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 489, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 499, s: ['7', '7', '7', '7', '7', '7', '7'] },
      { max: Infinity, s: ['7', '7', '7', '7', '7', '7', '7'] },
    ];
    const bottoms = [
      { min: 30, max: 33, size: 'A' },
      { min: 34, max: 37, size: 'B' },
      { min: 38, max: 40, size: 'C' },
      { min: 41, max: 44, size: 'D' },
      { min: 45, max: 49, size: 'E' },
      { min: 50, max: 54, size: 'F' },
      { min: 55, max: 60, size: 'G' },
      { min: 61, max: 65, size: 'H' },
    ];
    const heightColumn = (value) =>
      value <= 68 ? 0 : value <= 71 ? 1 : value <= 74 ? 2 : value <= 77 ? 3 : value <= 80 ? 4 : value <= 83 ? 5 : 6;
    const normalize = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/^size\s*/, '')
        .replace(/\s*\([^)]*\)\s*$/, '')
        .trim();

    const init = (scope = document) =>
      scope.querySelectorAll('[data-obflc]').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        const height = root.querySelector('[data-obflc-height]'),
          weight = root.querySelector('[data-obflc-weight]'),
          waist = root.querySelector('[data-obflc-waist]');
        const heightOut = root.querySelector('[data-obflc-height-output]'),
          weightOut = root.querySelector('[data-obflc-weight-output]'),
          waistOut = root.querySelector('[data-obflc-waist-output]');
        const topOut = root.querySelector('[data-obflc-top-size]'),
          bottomOut = root.querySelector('[data-obflc-bottom-size]'),
          modalSize = root.querySelector('[data-obflc-modal-size]');
        const modal = root.querySelector('[data-obflc-modal]'),
          primary = root.querySelector('[data-obflc-primary-stage]'),
          promo = root.querySelector('[data-obflc-promo-stage]');
        const selector = root.querySelector('[data-obflc-product-select]'),
          image = root.querySelector('[data-obflc-image]'),
          productTitle = root.querySelector('[data-obflc-title]'),
          variantText = root.querySelector('[data-obflc-variant]'),
          price = root.querySelector('[data-obflc-price]'),
          link = root.querySelector('[data-obflc-link]');
        const add = root.querySelector('[data-obflc-add]'),
          addLabel = root.querySelector('[data-obflc-add-label]'),
          status = root.querySelector('[data-obflc-status]');
        const productsNode = root.querySelector('[data-obflc-products]'),
          products = productsNode ? JSON.parse(productsNode.textContent) : [];
        const promoNode = root.querySelector('[data-obflc-promo-data]'),
          promoData = promoNode ? JSON.parse(promoNode.textContent) : null;
        const promoSize = root.querySelector('[data-obflc-promo-size]'),
          promoVariant = root.querySelector('[data-obflc-promo-variant]'),
          promoAdd = root.querySelector('[data-obflc-promo-add]'),
          promoLabel = root.querySelector('[data-obflc-promo-label]'),
          promoStatus = root.querySelector('[data-obflc-promo-status]');
        let topSize = '1',
          bottomSize = 'C',
          current = products[0] || null,
          selected = null,
          selectedPromo = null;

        const updateFit = () => {
          const inches = Number(height.value),
            pounds = Number(weight.value),
            row = matrix.find((item) => pounds <= item.max) || matrix[matrix.length - 1];
          topSize = row.s[heightColumn(inches)];
          bottomSize = (
            bottoms.find((item) => Number(waist.value) >= item.min && Number(waist.value) <= item.max) || bottoms[0]
          ).size;
          heightOut.textContent = `${Math.floor(inches / 12)}'${inches % 12}"`;
          weightOut.textContent = pounds >= 500 ? '500 lb+' : `${pounds} lb`;
          waistOut.textContent = `${waist.value} in`;
          topOut.textContent = topSize;
          bottomOut.textContent = bottomSize;
          if (modalSize) modalSize.textContent = topSize;
        };
        const chooseVariant = () => {
          if (!current) return false;
          const matches = current.variants.filter(
            (item) => normalize(item.options?.[current.sizeIndex]) === normalize(topSize)
          );
          selected = matches.find((item) => item.available) || matches[0] || null;
          variantText.textContent = selected ? selected.title : `Size ${topSize} unavailable`;
          price.textContent = selected?.price || '';
          if (image && (selected?.image || current.image)) {
            image.src = selected?.image || current.image;
            image.alt = current.title;
          }
          if (link) link.href = selected ? `${current.url}?variant=${selected.id}` : current.url;
          add.disabled = !selected?.available;
          return Boolean(selected?.available);
        };
        const chooseProduct = () => {
          current = products.find((item) => String(item.id) === selector.value) || products[0] || null;
          if (productTitle) productTitle.textContent = current?.title || '';
          chooseVariant();
          status.textContent = '';
        };
        [height, weight, waist].forEach((input) =>
          input?.addEventListener('input', () => {
            updateFit();
            chooseVariant();
          })
        );
        selector?.addEventListener('change', chooseProduct);
        if (addLabel) add.dataset.defaultLabel = addLabel.textContent.trim();
        if (promoLabel) promoAdd.dataset.defaultLabel = promoLabel.textContent.trim();
        const addToCart = async (id, properties = {}, silent = false) => {
          const form = new FormData();
          form.append('id', id);
          form.append('quantity', '1');
          Object.entries(properties).forEach(([key, value]) => form.append(`properties[${key}]`, value));
          const helper = window.Alpine?.store?.('xCartHelper');
          if (helper && !silent) {
            form.append(
              'sections',
              helper.getSectionsToRender().map((item) => item.id)
            );
            form.append('sections_url', window.location.pathname);
          }
          const response = await fetch(
            window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: form,
            }
          );
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || 'Unable to add this size.');
          if (!silent) {
            if (helper && result.sections) helper.reRenderSections(result.sections);
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          }
          return result;
        };
        const offerPromo = async () => {
          if (!promo || root.dataset.promoEligible !== 'true') return false;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
              headers: { Accept: 'application/json' },
            });
            if (response.ok) {
              const cart = await response.json();
              if (cart.items?.some((item) => item.properties?.['_ONE BONE offer'] === 'First-order underwear'))
                return false;
            }
          } catch (error) {}
          return true;
        };
        const preparePromo = () => {
          const requested = Number(waist.value),
            internal = (bottoms.find((item) => requested >= item.min && requested <= item.max) || bottoms[0]).size,
            matches =
              promoData?.variants?.filter(
                (item) => normalize(item.options?.[promoData.sizeIndex]) === normalize(internal)
              ) || [];
          selectedPromo = matches.find((item) => item.available) || matches[0] || null;
          promoSize.textContent = internal;
          promoVariant.textContent = `Size ${internal} · ${requested} in waist`;
          promoAdd.disabled = !selectedPromo?.available;
          promoStatus.textContent = selectedPromo?.available
            ? ''
            : `The option for a ${requested} in waist is unavailable.`;
        };
        const openCart = (result) => {
          const notice = window.Alpine?.store?.('xCartNoti');
          if (notice?.enable) notice.setItem(result);
          const mini = window.Alpine?.store?.('xMiniCart');
          if (mini?.openCart) mini.openCart();
          else
            window.setTimeout(() => {
              window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
            }, 250);
        };
        root.querySelector('[data-obflc-lock]')?.addEventListener('click', () => {
          updateFit();
          chooseProduct();
          try {
            localStorage.setItem('oneboneLockedTopSize', topSize);
            localStorage.setItem('oneboneLockedWaist', String(waist.value));
            localStorage.setItem('sizeBottom', bottomSize);
            localStorage.setItem('bottoms-product-size', bottomSize);
          } catch (error) {}
          primary.hidden = false;
          if (promo) promo.hidden = true;
          modal.showModal();
        });
        root.querySelector('[data-obflc-close]')?.addEventListener('click', () => modal.close());
        modal?.addEventListener('click', (event) => {
          if (event.target === modal) modal.close();
        });
        add?.addEventListener('click', async () => {
          if (!selected?.available) return;
          add.disabled = true;
          addLabel.textContent = 'Adding…';
          status.textContent = '';
          try {
            const shouldPromo = await offerPromo(),
              result = await addToCart(selected.id, {}, shouldPromo);
            addLabel.textContent = 'Added to bag ✓';
            status.textContent = `${current.title} in size ${topSize} is in your bag.`;
            if (shouldPromo) {
              preparePromo();
              primary.hidden = true;
              promo.hidden = false;
            } else {
              openCart(result);
            }
          } catch (error) {
            add.disabled = false;
            addLabel.textContent = add.dataset.defaultLabel;
            status.textContent = error.message || 'Unable to add this item.';
          }
        });
        promoAdd?.addEventListener('click', async () => {
          preparePromo();
          if (!selectedPromo?.available) return;
          promoAdd.disabled = true;
          promoLabel.textContent = 'Adding…';
          try {
            const result = await addToCart(selectedPromo.id, { '_ONE BONE offer': 'First-order underwear' });
            const code = root.dataset.promoDiscountCode?.trim();
            if (code)
              await fetch(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(code)}`, {
                credentials: 'same-origin',
              });
            promoLabel.textContent = 'Free pair added ✓';
            promoStatus.textContent = `Size ${bottomSize} is in your bag.`;
            modal.close();
            openCart(result);
          } catch (error) {
            promoAdd.disabled = false;
            promoLabel.textContent = promoAdd.dataset.defaultLabel;
            promoStatus.textContent = error.message || 'Unable to add this item.';
          }
        });
        updateFit();
        chooseProduct();
      });
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-fit-lock"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The line item property the new-customer gift discount function looks for.
    // It has to match snippets/gwp-gift.liquid and assets/gwp-gift.js, and the
    // `_gwp` key the checkout notice reads. Without it the function leaves the
    // line at full price, because it cannot tell a gift from a deliberate
    // purchase of the same boxer brief.
    //
    // Which variants may carry it is decided in Liquid, above: the promo variant
    // list is already narrowed to gwp.gift_variants, so anything this resolves
    // by size is a variant the function will discount. Nothing here re-checks
    // that — a second opinion could only differ from the first, and would be the
    // weaker of the two.
    const GIFT_PROPERTY = '_gwp';
    const GIFT_PROPERTY_VALUE = 'new-customer-underwear';

    // The tops matrix and the A-H waist ranges both live in assets/fit-finder.js
    // and are read through window.OneBoneFit. This section carried its own copy
    // of the matrix, which is how it drifted from the size guide before (OB-232);
    // there is nothing to drift from now.
    const normalize = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/^size\s*/, '')
        .replace(/\s*\([^)]*\)\s*$/, '')
        .trim();

    const init = (scope = document) => {
      scope.querySelectorAll('[data-obfl]').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';

        const modalSize = root.querySelector('[data-obfl-modal-size]');
        const lockButton = root.querySelector('[data-obfl-lock]');
        const lockedMessage = root.querySelector('[data-obfl-locked-message]');
        const calculatorStage = root.querySelector('[data-obfl-calculator-stage]');
        const inlineFlow = root.querySelector('[data-obfl-inline-flow]');
        const inlineMode = root.dataset.displayMode === 'inline';
        const modal = root.querySelector('[data-obfl-modal]');
        const closeButton = root.querySelector('[data-obfl-close]');
        const addButton = root.querySelector('[data-obfl-add]');
        const addLabel = root.querySelector('[data-obfl-add-label]');
        const status = root.querySelector('[data-obfl-status]');
        const variantTitle = root.querySelector('[data-obfl-variant-title]');
        const price = root.querySelector('[data-obfl-price]');
        const image = root.querySelector('[data-obfl-product-image]');
        const productLink = root.querySelector('[data-obfl-product-link]');
        const productTitle = root.querySelector('[data-obfl-product-title]');
        const picker = root.querySelector('[data-obfl-picker]');
        const swatchTrack = root.querySelector('[data-obfl-swatches]');
        const swatchPrev = root.querySelector('[data-obfl-swatch-prev]');
        const swatchNext = root.querySelector('[data-obfl-swatch-next]');
        const swatches = Array.from(root.querySelectorAll('[data-obfl-swatch]'));
        const productsNode = root.querySelector('[data-obfl-products]');
        const products = productsNode ? JSON.parse(productsNode.textContent) : { fallback: null, rules: [] };
        const primaryStage = root.querySelector('[data-obfl-primary-stage]');
        const promoStage = root.querySelector('[data-obfl-promo-stage]');
        const promoSizeBadge = root.querySelector('[data-obfl-promo-size-badge]');
        const promoResult = root.querySelector('[data-obfl-promo-result]');
        const promoVariantTitle = root.querySelector('[data-obfl-promo-variant-title]');
        const promoAdd = root.querySelector('[data-obfl-promo-add]');
        const promoAddLabel = root.querySelector('[data-obfl-promo-add-label]');
        const promoStatus = root.querySelector('[data-obfl-promo-status]');
        const promoNode = root.querySelector('[data-obfl-promo-variants]');
        const promoData = promoNode ? JSON.parse(promoNode.textContent) : null;
        let currentProduct = products.fallback;
        let recommendedSize = '2';
        let recommendedWaist = 40;
        let recommendedBottom = '';
        let selectedVariant = null;
        let promoVariant = null;
        // Set once the shopper chooses a garment, and never cleared: from then
        // on the sliders re-size their choice rather than replacing it.
        let pickedProductId = null;

        if (inlineMode && inlineFlow) {
          if (primaryStage) inlineFlow.appendChild(primaryStage);
          if (promoStage) inlineFlow.appendChild(promoStage);
        }

        const renderProductImage = (source) => {
          if (!image || !source) return;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
          image.alt = currentProduct?.title || image.alt;
        };

        // Can this product actually be bought in the size just recommended?
        // Anything that cannot is a dead end: the add button is the only way
        // through to the free pair, and it disables itself on an unavailable
        // variant.
        const canServeSize = (entry, size) =>
          Boolean(entry) &&
          (entry.variants || []).some(
            (variant) => variant.available && normalize(variant.options?.[entry.sizeIndex]) === normalize(size)
          );

        const candidatePool = () => ((products.candidates || []).length ? products.candidates : [products.fallback]);

        // Offer only what the shopper can actually buy in the size on screen.
        // Hiding rather than marking means every swatch left is a real route to
        // the free pair, and `hidden` takes the button out of the tab order and
        // the accessibility tree in one move.
        //
        // Availability is per size, so this is re-run on every slider move: a
        // garment hidden at one size comes back at another.
        // The block whose band the shopper's height falls in, matched the same
        // way chooseProduct matches it so the two cannot disagree.
        const activeRule = (inches) => (products.rules || []).find(
          (rule) => rule.enabled && inches >= Number(rule.minHeight) && inches <= Number(rule.maxHeight)
        );

        const markSwatches = (size, inches) => {
          const rule = activeRule(inches);
          swatches.forEach((swatch) => {
            const entry = entryFor(swatch);
            swatch.setAttribute('aria-label', swatch.dataset.productTitle || '');
            // A swatch that exists only to carry a recommendation is on offer
            // only while that recommendation is the one applying.
            const ruleOnly = swatch.dataset.obflRuleSwatch !== undefined;
            const carriesRule = Boolean(rule) && String(rule.id) === swatch.dataset.productId;
            swatch.hidden = !entry || (ruleOnly && !carriesRule) || !canServeSize(entry, size);
            if (swatch.hidden || !entry) return;
            // The tile was rendered with the default variant's price. Correct it
            // to the one the shopper would actually be charged in their size —
            // sizes can be priced differently, and the tile is now the only
            // place a price appears.
            const priceNode = swatch.querySelector('[data-obfl-swatch-price]');
            const sized = entry.variants.find(
              (variant) => variant.available && normalize(variant.options?.[entry.sizeIndex]) === normalize(size)
            );
            if (priceNode && sized?.price) priceNode.textContent = sized.price;
          });
          // Lead the row with the recommendation. Done after the visibility
          // pass and by product id, so it works whether the garment came from
          // the collection — the usual case, and the one this missed — or from
          // a block whose product the collection does not carry. Moved in the
          // DOM rather than with `order`, so arrow keys and the tab order
          // follow what is on screen.
          if (rule && swatchTrack) {
            const lead = visibleSwatches().find((swatch) => swatch.dataset.productId === String(rule.id));
            if (lead && swatchTrack.firstElementChild !== lead) swatchTrack.prepend(lead);
          }
          // Nothing in the collection comes in this size. An empty grid under a
          // live label reads as broken, so the whole picker steps aside and the
          // stage carries the "size unavailable" message on its own.
          if (picker) picker.hidden = !swatches.some((swatch) => !swatch.hidden);
          // Hiding a swatch changes how far the row can scroll.
          updateRailControls();
        };

        // Read from the track rather than the array the swatches were collected
        // into, because a height recommendation is moved to the front of the row
        // and arrow keys have to walk what is on screen, in that order.
        const visibleSwatches = () => (swatchTrack
          ? Array.from(swatchTrack.querySelectorAll('[data-obfl-swatch]')).filter((swatch) => !swatch.hidden)
          : swatches.filter((swatch) => !swatch.hidden));

        // A swatch is either one of the collection's candidates or a height
        // recommendation's product, which lives in products.rules rather than
        // the candidate pool.
        const entryFor = (swatch) => {
          const id = swatch.dataset.productId;
          return candidatePool().find((item) => String(item.id) === id)
            || (products.rules || []).find((rule) => rule.enabled && String(rule.id) === id)
            || null;
        };

        const scrollBehavior = () =>
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        // One near-screenful per press, as in onebone-category-micro-nav.
        const scrollRail = (direction) => {
          if (!swatchTrack) return;
          const amount = Math.max(swatchTrack.clientWidth * 0.72, 160);
          swatchTrack.scrollBy({ left: amount * direction, behavior: scrollBehavior() });
        };

        // The controls earn their place only when the rail actually overflows,
        // and go dead at each end. Worth calling whenever the row's width or
        // contents change — including when the dialog opens, since a closed
        // dialog has no layout and every measurement here would read zero.
        const updateRailControls = () => {
          if (!swatchTrack || !swatchPrev || !swatchNext) return;
          const maxScroll = Math.max(swatchTrack.scrollWidth - swatchTrack.clientWidth, 0);
          const overflows = maxScroll > 2;
          swatchPrev.hidden = !overflows;
          swatchNext.hidden = !overflows;
          swatchPrev.disabled = swatchTrack.scrollLeft <= 2;
          swatchNext.disabled = swatchTrack.scrollLeft >= maxScroll - 2;
        };

        // On one line most of the row is off-screen, so a selection the shopper
        // cannot see is no better than none. Only move when the selection
        // actually changes, or dragging a slider would yank the row about.
        let revealedSwatchId = null;
        const revealSwatch = (swatch) => {
          if (!swatch) return;
          if (swatch.dataset.productId === revealedSwatchId) return;
          revealedSwatchId = swatch.dataset.productId;
          swatch.scrollIntoView({ behavior: scrollBehavior(), block: 'nearest', inline: 'nearest' });
        };

        // Only the chosen swatch stays in the tab order; arrow keys move within
        // the group, which is what a radiogroup is expected to do. Hidden
        // swatches are never checked and never tabbable — a checked radio
        // nobody can see is not a selection.
        const syncSwatches = () => {
          const currentId = currentProduct?.id == null ? null : String(currentProduct.id);
          const visible = visibleSwatches();
          let current = visible.find((swatch) => swatch.dataset.productId === currentId) || visible[0] || null;
          swatches.forEach((swatch) => {
            const isCurrent = swatch === current;
            swatch.setAttribute('aria-checked', String(isCurrent));
            swatch.tabIndex = isCurrent ? 0 : -1;
          });
          revealSwatch(current);
        };

        const chooseProduct = (inches, size) => {
          // A garment the shopper picked themselves is not re-picked for them.
          // Moving a slider re-sizes their choice; it does not swap the choice
          // out, which would be the section overruling them mid-decision.
          // A pick this size has taken out of stock cannot stay: its swatch is
          // about to be hidden, and the selection has to be something the
          // shopper can still see. Release it and let the auto-pick choose
          // again rather than stranding the stage on a garment with no swatch.
          if (pickedProductId) {
            const picked = candidatePool().find((entry) => String(entry.id) === pickedProductId);
            if (!picked || !canServeSize(picked, size)) pickedProductId = null;
          }
          if (pickedProductId) {
            const picked = candidatePool().find((entry) => String(entry.id) === pickedProductId);
            if (picked) currentProduct = picked;
          } else {
            const match = (products.rules || []).find(
              (rule) => rule.enabled && inches >= Number(rule.minHeight) && inches <= Number(rule.maxHeight)
            );
            const pool = candidatePool();
            // A height rule is a deliberate substitution, so it still wins its
            // range — but only while it can be fulfilled. Once it cannot, the
            // collection is walked in its own order, and the pinned product is
            // the last word so a fully sold-out section still shows a garment
            // instead of an empty modal.
            if (match && canServeSize(match, size)) {
              currentProduct = match;
            } else {
              currentProduct = pool.find((entry) => canServeSize(entry, size)) || match || pool[0] || products.fallback;
            }
          }
          if (!currentProduct) return;
          if (productTitle) productTitle.textContent = currentProduct.title || '';
          renderProductImage(currentProduct.image);
          if (productLink) productLink.href = currentProduct.url;
          markSwatches(size, inches);
          // Keep the control showing what is actually on the stage, including
          // the opening auto-pick the shopper has not touched.
          syncSwatches();
        };

        // The shared tool renders the sliders and the two size cards, and the
        // shared engine answers with the sizes. Everything below reads that
        // answer rather than measuring anything itself, so there is one set of
        // ranges in the theme and one place a size can come from.
        //
        // assets/fit-finder.js is deferred and may land after this script, so
        // lastHeight keeps the fit lock's height bands working from whatever it
        // has until the engine reports for the first time.
        let lastHeight = 72;

        const readProfile = () => {
          const profile = window.OneBoneFit?.getProfile();
          if (!profile) return null;
          lastHeight = Number(profile.height) || lastHeight;
          recommendedSize = String(profile.top);
          recommendedWaist = Number(profile.waist) || recommendedWaist;
          recommendedBottom = profile.bottom || '';
          return profile;
        };

        const update = () => {
          readProfile();
          chooseProduct(lastHeight, recommendedSize);
          if (modalSize) modalSize.textContent = recommendedSize;
          syncPromoSelection();
        };

        const selectVariant = () => {
          if (!currentProduct) return false;
          const matching = currentProduct.variants.filter(
            (variant) => normalize(variant.options?.[currentProduct.sizeIndex]) === normalize(recommendedSize)
          );
          selectedVariant = matching.find((variant) => variant.available) || matching[0] || null;
          if (productTitle) productTitle.textContent = currentProduct.title || '';
          // A garment with no variant in this size at all — not even a sold-out
          // one — used to leave the stage as it was, so the shopper read the
          // previous garment's price beside their new choice and could add it.
          // Show the choice they made, priced at nothing, and shut the button.
          if (!selectedVariant) {
            if (variantTitle) variantTitle.textContent = `Not made in size ${recommendedSize}`;
            if (price) price.textContent = '';
            if (!currentProduct.imageOverride) renderProductImage(currentProduct.image);
            if (productLink) productLink.href = currentProduct.url;
            if (addButton) addButton.disabled = true;
            if (addLabel) addLabel.textContent = 'Size unavailable';
            return false;
          }
          if (variantTitle) variantTitle.textContent = selectedVariant.title;
          if (price) price.textContent = selectedVariant.price;
          if (selectedVariant.image && !currentProduct.imageOverride) renderProductImage(selectedVariant.image);
          if (productLink) productLink.href = `${currentProduct.url}?variant=${selectedVariant.id}`;
          if (addButton) addButton.disabled = !selectedVariant.available;
          if (addLabel)
            addLabel.textContent = selectedVariant.available ? addButton.dataset.defaultLabel : 'Size unavailable';
          return true;
        };

        // Fired by assets/fit-finder.js whenever any fit finder on the page
        // changes, so moving the shared sliders restages the product and
        // re-sizes the free pair without this section watching the inputs.
        document.addEventListener('onebone:fit:change', update);

        const pickSwatch = (swatch) => {
          if (!swatch) return;
          pickedProductId = swatch.dataset.productId;
          if (status) status.textContent = '';
          chooseProduct(lastHeight, recommendedSize);
          selectVariant();
        };

        swatchPrev?.addEventListener('click', () => scrollRail(-1));
        swatchNext?.addEventListener('click', () => scrollRail(1));
        swatchTrack?.addEventListener('scroll', updateRailControls, { passive: true });
        window.addEventListener('resize', updateRailControls);

        swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => pickSwatch(swatch));
          swatch.addEventListener('keydown', (event) => {
            const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
            if (!step) return;
            event.preventDefault();
            // Walk the visible swatches only — an arrow key must not land on a
            // garment that is not being offered.
            const visible = visibleSwatches();
            if (!visible.length) return;
            const from = visible.indexOf(swatch);
            const next = visible[(from + step + visible.length) % visible.length];
            pickSwatch(next);
            next.focus();
          });
        });

        if (addButton && addLabel) addButton.dataset.defaultLabel = addLabel.textContent.trim();
        if (promoAdd && promoAddLabel) promoAdd.dataset.defaultLabel = promoAddLabel.textContent.trim();

        // The offer stage no longer asks for a waist, so the free pair is
        // resolved from the measurement the calculator already has. Kept in step
        // with the slider so the pair is ready the moment the stage appears.
        const syncPromoSelection = () => {
          if (!promoStage) return null;
          const visibleWaist = `${recommendedWaist} in`;
          const internalSize = recommendedBottom || window.OneBoneFit?.recommendBottom(recommendedWaist) || '';
          recommendedBottom = internalSize;
          const matching = internalSize
            ? (promoData?.variants || []).filter(
                (variant) => normalize(variant.options?.[promoData.sizeIndex]) === normalize(internalSize)
              )
            : [];
          promoVariant = matching.find((variant) => variant.available) || matching[0] || null;
          if (promoSizeBadge) promoSizeBadge.textContent = `${recommendedWaist}\u2033`;
          if (promoVariantTitle)
            promoVariantTitle.textContent = internalSize
              ? `${visibleWaist} waist — size ${internalSize}`
              : `${visibleWaist} waist`;
          if (promoResult) promoResult.hidden = false;
          const available = Boolean(promoVariant?.available);
          if (promoAdd) promoAdd.disabled = !available;
          if (promoAddLabel) promoAddLabel.textContent = available ? promoAdd.dataset.defaultLabel : 'Size unavailable';
          if (promoStatus)
            promoStatus.textContent =
              available || !internalSize ? '' : `The option for a ${visibleWaist} waist is currently unavailable.`;
          return promoVariant;
        };

        const addToCart = async (variantId, properties = {}) => {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          Object.entries(properties).forEach(([key, value]) => formData.append(`properties[${key}]`, value));
          const helper = window.Alpine?.store?.('xCartHelper');
          if (helper) {
            formData.append(
              'sections',
              helper.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || 'Unable to add this size.');
          if (helper && result.sections) helper.reRenderSections(result.sections);
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          return result;
        };

        const showPromo = async () => {
          if (!promoStage || root.dataset.promoEligible !== 'true') return false;
          try {
            const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
              headers: { Accept: 'application/json' },
            });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              const items = cart.items || [];
              // GIFT_PROPERTY is the current marker; the old key is still
              // checked so a cart from before this change is not offered a
              // second pair.
              const isGift = (item) =>
                Boolean(item.properties?.[GIFT_PROPERTY]) ||
                item.properties?.['_ONE BONE offer'] === 'First-order underwear';
              if (items.some(isGift)) return false;

              // The function requires a purchase alongside the gift, and honours
              // the same minimum. Offering the pair below the threshold would
              // mean the discount is refused and the shopper pays for it.
              const paid = items
                .filter((item) => !isGift(item))
                .reduce((total, item) => total + (item.final_line_price || 0), 0);
              const minimum = Number(root.dataset.promoMinSubtotal || 0);
              if (paid <= 0 || paid < minimum) return false;
            }
          } catch (error) {}
          primaryStage.hidden = true;
          promoStage.hidden = false;
          if (promoStatus) promoStatus.textContent = '';
          syncPromoSelection();
          return true;
        };

        lockButton?.addEventListener('click', () => {
          update();
          try {
            localStorage.setItem('oneboneLockedTopSize', recommendedSize);
            localStorage.setItem('oneboneLockedWaist', String(recommendedWaist));
            if (recommendedBottom) localStorage.setItem('bottoms-product-size', recommendedBottom);
          } catch (error) {}
          // Share the whole fit with the rest of the theme (OB-232). The
          // measurements go in first so the engine recalculates from them, then
          // the two sizes shown here are pinned so nothing can disagree with
          // what the shopper just read.
          // The shared tool already persisted the measurements as they were
          // moved, so there is nothing to write back. Pinning the two sizes
          // still matters: it marks them as the shopper's deliberate choice, so
          // a later calculated value cannot quietly disagree with what they
          // just read here.
          window.OneBoneFit?.setSizes({ top: recommendedSize, bottom: recommendedBottom || undefined });
          if (lockedMessage) {
            lockedMessage.textContent = recommendedBottom
              ? `Size ${recommendedSize} and a ${recommendedWaist} in waist are locked in.`
              : `Size ${recommendedSize} is locked in.`;
            lockedMessage.hidden = false;
          }
          if (status) status.textContent = '';
          selectVariant();
          if (primaryStage) primaryStage.hidden = false;
          if (promoStage) promoStage.hidden = true;
          if (inlineMode && inlineFlow) {
            calculatorStage.hidden = true;
            inlineFlow.hidden = false;
            inlineFlow.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'nearest',
            });
          } else {
            modal?.showModal();
          }
          // Only now does the row have a width to measure. The selection was
          // resolved while the dialog was still closed, and a closed dialog has
          // no scroller to move — revealSwatch ran, marked itself done and
          // scrolled nothing, so the shopper opened the modal to a selected
          // garment somewhere off to the right. Forget what was revealed and
          // sync again now that there is a laid-out row to scroll.
          updateRailControls();
          revealedSwatchId = null;
          syncSwatches();
        });

        closeButton?.addEventListener('click', () => modal?.close());
        modal?.addEventListener('click', (event) => {
          if (event.target === modal) modal.close();
        });

        addButton?.addEventListener('click', async () => {
          if (!selectedVariant?.available) return;
          addButton.disabled = true;
          addLabel.textContent = 'Adding…';
          if (status) status.textContent = '';

          try {
            const result = await addToCart(selectedVariant.id);
            addLabel.textContent = 'Added to bag ✓';
            if (status) status.textContent = `Size ${recommendedSize} is in your bag.`;
            if (!(await showPromo())) {
              const notice = window.Alpine?.store?.('xCartNoti');
              if (notice?.enable) notice.setItem(result);
              const miniCart = window.Alpine?.store?.('xMiniCart');
              if (miniCart && !notice?.enable) miniCart.openCart();
            }
          } catch (error) {
            addLabel.textContent = addButton.dataset.defaultLabel;
            addButton.disabled = false;
            if (status) status.textContent = error.message || 'Unable to add this item. Please try again.';
          }
        });

        promoAdd?.addEventListener('click', async () => {
          // The waist came from the calculator, so there is nothing to read from
          // this stage — only the variant it resolved to.
          const requestedWaist = recommendedWaist;
          const visibleSize = `${requestedWaist} in`;
          const variant = promoVariant || syncPromoSelection();
          if (!variant?.available) {
            if (promoStatus)
              promoStatus.textContent = `The option for a ${visibleSize} waist is currently unavailable.`;
            return;
          }
          promoAdd.disabled = true;
          promoAddLabel.textContent = 'Locking it in…';
          if (promoStatus) promoStatus.textContent = '';
          try {
            const result = await addToCart(variant.id, { [GIFT_PROPERTY]: GIFT_PROPERTY_VALUE });
            const discountCode = root.dataset.promoDiscountCode?.trim();
            if (discountCode) {
              await fetch(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(discountCode)}`, {
                credentials: 'same-origin',
              });
            }
            try {
              localStorage.setItem('oneboneFirstOrderPromoClaimed', 'true');
            } catch (error) {}
            promoAddLabel.textContent = 'Free pair added ✓';
            if (promoStatus) promoStatus.textContent = `${visibleSize} waist is locked in and added to your bag.`;
            const notice = window.Alpine?.store?.('xCartNoti');
            if (notice?.enable) notice.setItem(result);
            if (modal?.open) modal.close();
            const miniCart = window.Alpine?.store?.('xMiniCart');
            if (miniCart?.openCart) {
              miniCart.openCart();
            } else {
              window.setTimeout(() => {
                window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
              }, 250);
            }
          } catch (error) {
            promoAdd.disabled = false;
            promoAddLabel.textContent = promoAdd.dataset.defaultLabel;
            if (promoStatus) promoStatus.textContent = error.message || 'Unable to add this item. Please try again.';
          }
        });

        // The shared tool restores its own sliders from the stored profile, so
        // there is nothing to seed here beyond this section's copy of the sizes.
        // The engine is deferred and may land after this script, hence the wait.
        update();
        if (!window.OneBoneFit) {
          document.addEventListener('onebone:fit:ready', update, { once: true });
        }
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-fit-runway"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ob-fit-runway')) {
  customElements.define('ob-fit-runway', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const matrix = [{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}];
      const models = [...this.querySelectorAll('[data-model]')];
      if (!models.length) return;
      const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      const stage = this.querySelector('[data-stage]');
      const sizeButtons = [...this.querySelectorAll('[data-size-pick]')];
      const height = this.querySelector('input[data-height]');
      const weight = this.querySelector('input[data-weight]');
      let selected = 0, filter = null, pool = models;
      const format = h => `${Math.floor(h / 12)}′${h % 12}″`;
      const message = text => { this.querySelector('[data-message]').textContent = text; };
      const setSizeButtons = () => {
        sizeButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizePick === filter)));
        this.querySelector('[data-all]').setAttribute('aria-pressed', String(filter === null));
      };
      const show = model => {
        selected = models.indexOf(model);
        const current = pool.indexOf(model);
        models.forEach(item => {
          const index = models.indexOf(item), offset = index - selected;
          item.hidden = false;
          item.style.setProperty('--offset', offset);
          item.style.setProperty('--scale', Math.max(.64, 1 - Math.abs(offset) * .16));
          item.style.setProperty('--opacity', Math.max(.12, 1 - Math.abs(offset) * .3));
          item.style.setProperty('--blur', offset === 0 ? '0px' : '.45px');
          item.style.setProperty('--layer', 20 - Math.abs(offset));
          item.setAttribute('aria-hidden', String(item !== model));
        });
        const stats = [];
        if (Number(model.dataset.height) > 0) stats.push(format(Number(model.dataset.height)));
        if (Number(model.dataset.weight) > 0) stats.push(`${model.dataset.weight} lb`);
        if (Number(model.dataset.waist) > 0) stats.push(`${model.dataset.waist}″ ${labels.waist}`);
        this.querySelector('.obfr__details [data-name]').textContent = model.dataset.name;
        this.querySelector('[data-stats]').textContent = stats.length ? stats.join(' · ') : labels.unknown;
        this.querySelector('[data-worn]').textContent = [model.dataset.size ? `${labels.wears} ${model.dataset.size}` : labels.unverified, model.dataset.bottom ? `${labels.bottom} ${model.dataset.bottom}` : ''].filter(Boolean).join(' · ');
        this.querySelector('[data-position]').textContent = `${current + 1} ${labels.of} ${pool.length}`;
        this.querySelector('[data-prev]').disabled = current <= 0;
        this.querySelector('[data-next]').disabled = current >= pool.length - 1;
      };
      const move = direction => {
        const current = pool.indexOf(models[selected]);
        show(pool[Math.max(0, Math.min(pool.length - 1, current + direction))]);
      };
      const clearFilter = () => { filter = null; pool = models; setSizeButtons(); message(''); };
      sizeButtons.forEach(button => button.addEventListener('click', () => {
        const matching = models.filter(model => model.dataset.size === button.dataset.sizePick);
        if (!matching.length) { message(`${labels.wears} ${button.dataset.sizePick}: ${labels.noSize}`); return; }
        filter = button.dataset.sizePick;
        pool = matching;
        setSizeButtons();
        message(labels.oneBody);
        show(pool[0]);
      }));
      this.querySelector('[data-all]').addEventListener('click', () => { clearFilter(); show(models[selected]); });
      this.querySelector('[data-prev]').addEventListener('click', () => move(-1));
      this.querySelector('[data-next]').addEventListener('click', () => move(1));
      stage.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') show(pool[0]);
        else if (event.key === 'End') show(pool[pool.length - 1]);
        else move(event.key === 'ArrowRight' ? 1 : -1);
      });
      let pointer = null;
      stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        stage.setPointerCapture(event.pointerId);
      });
      stage.addEventListener('pointerup', event => {
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) move(dx < 0 ? 1 : -1);
        pointer = null;
      });
      stage.addEventListener('pointercancel', () => { pointer = null; });
      stage.addEventListener('dragstart', event => event.preventDefault());
      const update = () => {
        const h = Number(height.value), w = Number(weight.value);
        const column = h <= 68 ? 0 : h <= 71 ? 1 : h <= 74 ? 2 : h <= 77 ? 3 : h <= 80 ? 4 : h <= 83 ? 5 : 6;
        this.querySelector('[data-height-label]').textContent = format(h);
        this.querySelector('[data-weight-label]').textContent = `${w} lb`;
        height.setAttribute('aria-valuetext', format(h));
        weight.setAttribute('aria-valuetext', `${w} lb`);
        this.querySelector('[data-estimate]').textContent = matrix.find(row => w <= row.max).s[column];
        const valid = models.filter(model => Number(model.dataset.height) > 0 && Number(model.dataset.weight) > 0);
        const score = model => Math.abs(w - Number(model.dataset.weight)) + Math.abs(h - Number(model.dataset.height)) * 14;
        clearFilter();
        if (valid.length) show(valid.reduce((best, model) => score(model) < score(best) ? model : best));
        else message(labels.noMatch);
      };
      height.addEventListener('input', update);
      weight.addEventListener('input', update);
      this.querySelector('[data-reset]').addEventListener('click', update);
      this.addEventListener('shopify:block:select', event => {
        const model = event.target.closest('[data-model]');
        if (model) { clearFilter(); show(model); }
      });
      show(models[Math.floor(models.length / 2)]);
      setSizeButtons();
      this.classList.add('is-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-guided-outfit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const matrix = [
      { max: 179, s: ['-2', '-2', '-2', '-1', '-1', '-1', '-1'] },
      { max: 189, s: ['-1', '-1', '-1', '-1', '-1', '-1', '-1'] },
      { max: 199, s: ['0', '0', '-1', '-1', '-1', '-1', '-1'] },
      { max: 209, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 219, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 229, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 239, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 249, s: ['0', '0', '0', '0', '0', '0', '0'] },
      { max: 259, s: ['1', '1', '1', '0', '0', '0', '0'] },
      { max: 269, s: ['1', '1', '1', '1', '1', '1', '1'] },
      { max: 279, s: ['2', '1', '1', '1', '1', '1', '1'] },
      { max: 289, s: ['2', '2', '1', '1', '1', '1', '1'] },
      { max: 299, s: ['2', '2', '1', '1', '1', '1', '1'] },
      { max: 309, s: ['2', '2', '1', '1', '1', '1', '1'] },
      { max: 319, s: ['3', '3', '2', '2', '2', '1', '1'] },
      { max: 329, s: ['3', '3', '2', '2', '2', '2', '2'] },
      { max: 339, s: ['3', '3', '3', '3', '3', '3', '3'] },
      { max: 349, s: ['4', '4', '3', '3', '3', '3', '3'] },
      { max: 359, s: ['4', '4', '3', '3', '3', '3', '3'] },
      { max: 369, s: ['4', '4', '4', '4', '4', '4', '4'] },
      { max: 379, s: ['4', '4', '4', '4', '4', '4', '4'] },
      { max: 389, s: ['5', '5', '4', '4', '4', '3', '3'] },
      { max: 399, s: ['5', '5', '5', '4', '4', '4', '4'] },
      { max: 409, s: ['5', '5', '5', '5', '5', '5', '5'] },
      { max: 419, s: ['5', '5', '5', '5', '5', '5', '5'] },
      { max: 429, s: ['5', '5', '5', '5', '5', '5', '5'] },
      { max: 439, s: ['6', '5', '5', '5', '5', '5', '5'] },
      { max: 449, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 459, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 469, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 479, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 489, s: ['6', '6', '6', '6', '6', '6', '6'] },
      { max: 499, s: ['7', '7', '7', '7', '7', '7', '7'] },
      { max: Infinity, s: ['7', '7', '7', '7', '7', '7', '7'] },
    ];
    const bottoms = [
      { min: 30, max: 33, size: 'A' },
      { min: 34, max: 37, size: 'B' },
      { min: 38, max: 40, size: 'C' },
      { min: 41, max: 44, size: 'D' },
      { min: 45, max: 49, size: 'E' },
      { min: 50, max: 54, size: 'F' },
      { min: 55, max: 60, size: 'G' },
      { min: 61, max: 65, size: 'H' },
    ];
    const column = (h) => (h <= 68 ? 0 : h <= 71 ? 1 : h <= 74 ? 2 : h <= 77 ? 3 : h <= 80 ? 4 : h <= 83 ? 5 : 6);
    const normalize = (v) =>
      String(v || '')
        .toLowerCase()
        .replace(/^size\s*/, '')
        .replace(/\s*\([^)]*\)\s*$/, '')
        .trim();
    const saved = (keys) => {
      for (const key of keys) {
        try {
          const value = localStorage.getItem(key);
          if (value) return value;
        } catch (error) {}
      }
      return '';
    };

    const init = (scope = document) =>
      scope.querySelectorAll('[data-obgo]').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        const modal = root.querySelector('[data-obgo-modal]');
        const data = JSON.parse(
          root.querySelector('[data-obgo-data]')?.textContent || '{"paths":[],"recommendations":[]}'
        );
        const screens = {
          paths: root.querySelector('[data-obgo-path-screen]'),
          fit: root.querySelector('[data-obgo-fit-screen]'),
          product: root.querySelector('[data-obgo-product-screen]'),
          empty: root.querySelector('[data-obgo-empty-screen]'),
        };
        const height = root.querySelector('[data-obgo-height]'),
          weight = root.querySelector('[data-obgo-weight]'),
          waist = root.querySelector('[data-obgo-waist]');
        const heightOut = root.querySelector('[data-obgo-height-output]'),
          weightOut = root.querySelector('[data-obgo-weight-output]'),
          waistOut = root.querySelector('[data-obgo-waist-output]');
        const topOut = root.querySelector('[data-obgo-top-size]'),
          bottomOut = root.querySelector('[data-obgo-bottom-size]');
        const productImage = root.querySelector('[data-obgo-product-image]'),
          productHeading = root.querySelector('[data-obgo-product-heading]'),
          productCopy = root.querySelector('[data-obgo-product-copy]'),
          productEyebrow = root.querySelector('[data-obgo-product-eyebrow]');
        const productTitle = root.querySelector('[data-obgo-product-title]'),
          variantTitle = root.querySelector('[data-obgo-variant-title]'),
          price = root.querySelector('[data-obgo-price]'),
          sizeBadge = root.querySelector('[data-obgo-product-size]'),
          details = root.querySelector('[data-obgo-details]');
        const progress = root.querySelector('[data-obgo-progress]'),
          add = root.querySelector('[data-obgo-add]'),
          addLabel = root.querySelector('[data-obgo-add-label]'),
          status = root.querySelector('[data-obgo-status]');
        let profile = {
          top:
            String(root.dataset.customerTopSize || '').trim() ||
            saved(['oneboneLockedTopSize', 'sizeTop', 'tops-product-size']),
          bottom: String(root.dataset.customerBottomSize || '').trim() || saved(['sizeBottom', 'bottoms-product-size']),
        };
        let activePath = '',
          sequence = [],
          index = 0,
          selectedVariant = null;
        const defaultAddLabel = addLabel?.textContent.trim() || 'Add to bag';
        const show = (name) =>
          Object.entries(screens).forEach(([key, node]) => {
            if (node) node.hidden = key !== name;
          });
        const open = () => {
          show('paths');
          modal?.showModal();
          document.body.classList.add('obgo-modal-open');
        };
        const close = () => {
          modal?.close();
          document.body.classList.remove('obgo-modal-open');
        };
        root.querySelectorAll('[data-obgo-open]').forEach((button) => button.addEventListener('click', open));
        const anchor = root.dataset.triggerAnchor;
        if (anchor) {
          document
            .querySelectorAll(`a[href="#${CSS.escape(anchor)}"],button[data-ob-guided-shop="${CSS.escape(anchor)}"]`)
            .forEach((trigger) => {
              if (trigger.dataset.obgoBound === root.id) return;
              trigger.dataset.obgoBound = root.id || anchor;
              trigger.addEventListener('click', (event) => {
                event.preventDefault();
                open();
              });
            });
        }
        root.querySelector('[data-obgo-close]')?.addEventListener('click', close);
        modal?.addEventListener('close', () => document.body.classList.remove('obgo-modal-open'));
        modal?.addEventListener('click', (event) => {
          if (event.target === modal) close();
        });
        root
          .querySelectorAll('[data-obgo-back-paths]')
          .forEach((button) => button.addEventListener('click', () => show('paths')));

        const updateFit = () => {
          const h = Number(height?.value || 72),
            w = Number(weight?.value || 260),
            ws = Number(waist?.value || 40);
          profile.top = (matrix.find((row) => w <= row.max) || matrix[matrix.length - 1]).s[column(h)];
          profile.bottom = (bottoms.find((range) => ws >= range.min && ws <= range.max) || bottoms[0]).size;
          if (heightOut) heightOut.textContent = `${Math.floor(h / 12)}'${h % 12}"`;
          if (weightOut) weightOut.textContent = w >= 500 ? '500 lb+' : `${w} lb`;
          if (waistOut) waistOut.textContent = `${ws} in`;
          if (topOut) topOut.textContent = profile.top;
          if (bottomOut) bottomOut.textContent = profile.bottom;
        };
        height?.addEventListener('input', updateFit);
        weight?.addEventListener('input', updateFit);
        waist?.addEventListener('input', updateFit);
        const fitNeeded = () => sequence.some((item) => item.sizeSource !== 'none' && !profile[item.sizeSource]);
        const startPath = (key) => {
          activePath = key;
          sequence = (data.recommendations || [])
            .filter((item) => item.enabled && item.path === key)
            .sort((a, b) => Number(a.step) - Number(b.step))
            .slice(0, 5);
          index = 0;
          if (!sequence.length) {
            show('empty');
            return;
          }
          if (fitNeeded()) {
            updateFit();
            show('fit');
          } else renderProduct();
        };
        root
          .querySelectorAll('[data-obgo-path]')
          .forEach((button) => button.addEventListener('click', () => startPath(button.dataset.obgoPath)));
        root.querySelector('[data-obgo-lock-fit]')?.addEventListener('click', () => {
          updateFit();
          try {
            localStorage.setItem('oneboneLockedTopSize', profile.top);
            localStorage.setItem('sizeTop', profile.top);
            localStorage.setItem('tops-product-size', profile.top);
            localStorage.setItem('sizeBottom', profile.bottom);
            localStorage.setItem('bottoms-product-size', profile.bottom);
            localStorage.setItem('oneboneLockedWaist', String(waist?.value || 40));
          } catch (error) {}
          renderProduct();
        });

        const chooseVariant = (item) => {
          if (item.sizeSource === 'none')
            return item.variants.find((variant) => variant.available) || item.variants[0] || null;
          const wanted = profile[item.sizeSource];
          const matches = item.variants.filter(
            (variant) => normalize(variant.options?.[item.sizeIndex]) === normalize(wanted)
          );
          return matches.find((variant) => variant.available) || matches[0] || null;
        };
        const renderProduct = () => {
          const item = sequence[index];
          if (!item) {
            finish();
            return;
          }
          selectedVariant = chooseVariant(item);
          const selectedSize = item.sizeSource === 'none' ? 'Ready' : profile[item.sizeSource];
          const image = (!item.imageOverride && selectedVariant?.image) || item.image;
          if (productImage) {
            productImage.src = image || '';
            productImage.alt = item.title || item.heading || '';
            productImage.hidden = !image;
          }
          if (productHeading) productHeading.textContent = item.heading || item.title || '';
          if (productCopy) productCopy.innerHTML = item.copy || '';
          if (productEyebrow) productEyebrow.textContent = item.eyebrow || 'Built for your next room';
          if (productTitle) productTitle.textContent = item.title || '';
          if (variantTitle) variantTitle.textContent = selectedVariant?.title || '';
          if (price) price.textContent = selectedVariant?.price || '';
          if (sizeBadge) sizeBadge.textContent = selectedSize;
          if (details) {
            details.href = selectedVariant ? `${item.url}?variant=${selectedVariant.id}` : item.url || '';
            details.hidden = !item.url;
          }
          if (progress) progress.textContent = `Piece ${index + 1} of ${sequence.length}`;
          if (add) {
            add.disabled = !selectedVariant?.available;
          }
          if (addLabel)
            addLabel.textContent = selectedVariant?.available ? item.addLabel || defaultAddLabel : 'Size unavailable';
          if (status)
            status.textContent = selectedVariant?.available
              ? ''
              : `This piece is not currently available in size ${selectedSize}.`;
          show('product');
        };
        const addToCart = async (id) => {
          const form = new FormData();
          form.append('id', id);
          form.append('quantity', '1');
          form.append('properties[_Guided outfit]', activePath);
          const helper = window.Alpine?.store?.('xCartHelper');
          if (helper) {
            form.append(
              'sections',
              helper.getSectionsToRender().map((section) => section.id)
            );
            form.append('sections_url', window.location.pathname);
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: form,
          });
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || 'Unable to add this piece.');
          if (helper && result.sections) helper.reRenderSections(result.sections);
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          return result;
        };
        const finish = () => {
          close();
          const miniCart = window.Alpine?.store?.('xMiniCart');
          if (miniCart?.openCart) {
            miniCart.openCart();
          } else {
            window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          }
        };
        const next = () => {
          index += 1;
          if (index >= sequence.length) finish();
          else renderProduct();
        };
        add?.addEventListener('click', async () => {
          if (!selectedVariant?.available) return;
          add.disabled = true;
          if (addLabel) addLabel.textContent = 'Adding…';
          if (status) status.textContent = '';
          try {
            await addToCart(selectedVariant.id);
            if (addLabel) addLabel.textContent = 'Added ✓';
            if (status) status.textContent = 'In your bag. Here’s the next piece.';
            window.setTimeout(next, 450);
          } catch (error) {
            add.disabled = false;
            if (addLabel) addLabel.textContent = defaultAddLabel;
            if (status) status.textContent = error.message || 'Unable to add this piece. Please try again.';
          }
        });
        root.querySelector('[data-obgo-skip]')?.addEventListener('click', next);
        updateFit();
      });
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-model-fit-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ob-model-finder')) {
  customElements.define('ob-model-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const matrix = [{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}];
      const height = this.querySelector('input[data-height]');
      const weight = this.querySelector('input[data-weight]');
      const models = [...this.querySelectorAll('[data-model]')];
      const buttons = [...this.querySelectorAll('[data-pick]')];
      const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      const format = h => `${Math.floor(h / 12)}′${h % 12}″`;
      const show = (model, manual = false) => {
        models.forEach(item => { item.hidden = item !== model; });
        buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(models[index] === model)));
        this.querySelector('[data-name]').textContent = model?.dataset.name || '';
        this.querySelector('[data-stats]').textContent = model && Number(model.dataset.height) > 0 && Number(model.dataset.weight) > 0 ? `${format(Number(model.dataset.height))} · ${model.dataset.weight} lb` : labels.unknown;
        if (Number(model?.dataset.waist) > 0) this.querySelector('[data-stats]').textContent += ` · ${model.dataset.waist}″ ${labels.waist}`;
        this.querySelector('[data-worn]').textContent = [model?.dataset.size ? `${labels.worn} ${model.dataset.size}` : '', model?.dataset.bottom ? `${labels.bottom} ${model.dataset.bottom}` : ''].filter(Boolean).join(' · ');
        this.querySelector('[data-match-label]').textContent = manual ? labels.viewing : labels.closest;
      };
      const update = () => {
        const h = Number(height.value), w = Number(weight.value);
        const column = h <= 68 ? 0 : h <= 71 ? 1 : h <= 74 ? 2 : h <= 77 ? 3 : h <= 80 ? 4 : h <= 83 ? 5 : 6;
        this.querySelector('[data-height-label]').textContent = format(h);
        this.querySelector('[data-weight-label]').textContent = `${w} lb`;
        height.setAttribute('aria-valuetext', format(h));
        weight.setAttribute('aria-valuetext', `${w} lb`);
        this.querySelector('.obmf__size [data-size]').textContent = matrix.find(row => w <= row.max).s[column];
        const valid = models.filter(model => Number(model.dataset.height) > 0 && Number(model.dataset.weight) > 0);
        const score = model => Math.abs(w - Number(model.dataset.weight)) + Math.abs(h - Number(model.dataset.height)) * 14;
        show(valid.reduce((best, model) => !best || score(model) < score(best) ? model : best, null));
      };
      height.addEventListener('input', update);
      weight.addEventListener('input', update);
      buttons.forEach((button, index) => button.addEventListener('click', () => show(models[index], true)));
      this.querySelector('[data-reset]').addEventListener('click', update);
      this.addEventListener('shopify:block:select', event => {
        const model = event.target.closest('[data-model]');
        if (model) show(model, true);
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-new-customer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const f = (i) => `${Math.floor(i / 12)}'${i % 12}"`,
      matrix = [
        { max: 179, s: ['-2', '-2', '-2', '-1', '-1', '-1', '-1'] },
        { max: 189, s: ['-1', '-1', '-1', '-1', '-1', '-1', '-1'] },
        { max: 199, s: ['0', '0', '-1', '-1', '-1', '-1', '-1'] },
        { max: 209, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 219, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 229, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 239, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 249, s: ['0', '0', '0', '0', '0', '0', '0'] },
        { max: 259, s: ['1', '1', '1', '0', '0', '0', '0'] },
        { max: 269, s: ['1', '1', '1', '1', '1', '1', '1'] },
        { max: 279, s: ['2', '1', '1', '1', '1', '1', '1'] },
        { max: 289, s: ['2', '2', '1', '1', '1', '1', '1'] },
        { max: 299, s: ['2', '2', '1', '1', '1', '1', '1'] },
        { max: 309, s: ['2', '2', '1', '1', '1', '1', '1'] },
        { max: 319, s: ['3', '3', '2', '2', '2', '1', '1'] },
        { max: 329, s: ['3', '3', '2', '2', '2', '2', '2'] },
        { max: 339, s: ['3', '3', '3', '3', '3', '3', '3'] },
        { max: 349, s: ['4', '4', '3', '3', '3', '3', '3'] },
        { max: 359, s: ['4', '4', '3', '3', '3', '3', '3'] },
        { max: 369, s: ['4', '4', '4', '4', '4', '4', '4'] },
        { max: 379, s: ['4', '4', '4', '4', '4', '4', '4'] },
        { max: 389, s: ['5', '5', '4', '4', '4', '3', '3'] },
        { max: 399, s: ['5', '5', '5', '4', '4', '4', '4'] },
        { max: 409, s: ['5', '5', '5', '5', '5', '5', '5'] },
        { max: 419, s: ['5', '5', '5', '5', '5', '5', '5'] },
        { max: 429, s: ['5', '5', '5', '5', '5', '5', '5'] },
        { max: 439, s: ['6', '5', '5', '5', '5', '5', '5'] },
        { max: 449, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 459, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 469, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 479, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 489, s: ['6', '6', '6', '6', '6', '6', '6'] },
        { max: 499, s: ['7', '7', '7', '7', '7', '7', '7'] },
        { max: Infinity, s: ['7', '7', '7', '7', '7', '7', '7'] },
      ],
      heightColumn = (h) => (h <= 68 ? 0 : h <= 71 ? 1 : h <= 74 ? 2 : h <= 77 ? 3 : h <= 80 ? 4 : h <= 83 ? 5 : 6);
    document.querySelectorAll('[data-ob-fit-tool]').forEach((tool) => {
      if (tool.dataset.ready) return;
      tool.dataset.ready = 'true';
      const h = tool.querySelector('.js-ob-height'),
        w = tool.querySelector('.js-ob-weight'),
        hv = tool.querySelector('.js-ob-height-value'),
        wv = tool.querySelector('.js-ob-weight-value'),
        s = tool.querySelector('.js-ob-shirt-size'),
        n = tool.querySelector('.js-ob-fit-note'),
        unit = tool.dataset.weightUnit || 'lb',
        notes = {
          '-2': tool.getAttribute('data-note-size-minus-2'),
          '-1': tool.getAttribute('data-note-size-minus-1'),
          0: tool.getAttribute('data-note-size-0'),
          1: tool.getAttribute('data-note-size-1'),
          2: tool.getAttribute('data-note-size-2'),
          3: tool.getAttribute('data-note-size-3'),
          4: tool.getAttribute('data-note-size-4'),
          5: tool.getAttribute('data-note-size-5'),
          6: tool.getAttribute('data-note-size-6'),
          7: tool.getAttribute('data-note-size-7'),
        },
        u = () => {
          const ih = Number(h.value),
            iw = Number(w.value),
            row = matrix.find((r) => iw <= r.max) || matrix[matrix.length - 1],
            size = row.s[heightColumn(ih)];
          hv.textContent = f(ih);
          wv.textContent = iw >= 500 ? `500${unit}+` : `${iw} ${unit}`;
          s.textContent = size;
          n.textContent = notes[size] || notes['2'];
        };
      h.addEventListener('input', u);
      w.addEventListener('input', u);
      u();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-review-product"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const roots=[...document.querySelectorAll('[data-review-product]')];
 if(!roots.length||roots.every(root=>root.dataset.ready))return;
 roots.forEach(root=>root.dataset.ready='true');
 const normal=value=>String(value??'').trim().replace(/^size\s*/i,'').replace(/^(-?\d+)\s*\([^)]*\)$/,'$1');
 const initial=JSON.parse(roots[0].querySelector('[data-review-data]').textContent);
 const state={product:initial,size:null,colour:'',loading:false,adding:false,request:0,controller:null,error:''};
 const optionName=option=>typeof option==='string'?option:option.name;
 const sizeIndex=()=>state.product.options.findIndex(option=>/size/i.test(optionName(option)));
 const getVariant=()=>state.product.variants.find(v=>v.available&&normal(v.options[sizeIndex()])===state.size);
 const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:roots[0].dataset.currency,currencyDisplay:'code'}).format(cents/100);
 const path=value=>new URL(value,location.origin).pathname.replace(/\/$/,'');
 roots.forEach(root=>{
   const wrap=root.querySelector('[data-review-swatches]');
   const groups=[...wrap.querySelectorAll('.x-swatch-section')];
   if(groups.length>1){const details=document.createElement('details');const summary=document.createElement('summary');summary.textContent=root.querySelector('[data-review-data]').dataset.more;details.append(summary,...groups.slice(1));wrap.append(details);}
   wrap.querySelectorAll('a[data-swatch-name]').forEach(a=>{a.setAttribute('role','button');a.setAttribute('aria-pressed',String(a.classList.contains('is-active')));a.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();a.click();}});if(a.classList.contains('is-active')&&!state.colour)state.colour=a.dataset.swatchName;});
 });
 const update=()=>{
   const variant=getVariant(),display=variant||state.product.variants.find(v=>v.available)||state.product.variants[0];
   roots.forEach(root=>{
     root.dataset.productId=state.product.id;root.setAttribute('aria-busy',String(state.loading||state.adding));
     root.querySelector('[data-review-price]').textContent=money(display.price);
     const compare=root.querySelector('[data-review-compare]');compare.hidden=!(display.compare_at_price>display.price);compare.textContent=money(display.compare_at_price||0);
     const offer=root.querySelector('[data-review-offer-price]');if(offer)offer.textContent=money(Math.round(display.price*(1-Number(root.dataset.percent)/100)));
     root.querySelector('[data-review-colour]').textContent=state.colour;
     root.querySelector('[data-review-variant]').value=variant?.id||'';
     const sizes=root.querySelector('[data-review-sizes]');const index=sizeIndex();
     const values=[...new Set(state.product.variants.map(v=>normal(v.options[index])))];
     sizes.replaceChildren(...values.map(value=>{const label=document.createElement('label'),input=document.createElement('input'),span=document.createElement('span');input.type='radio';input.name=`review-size-${root.closest('[id]')?.id}`;input.value=value;input.checked=value===state.size;input.disabled=state.loading||state.adding||!state.product.variants.some(v=>v.available&&normal(v.options[index])===value);input.setAttribute('aria-label',value);span.textContent=value;input.addEventListener('change',()=>{state.size=value;state.error='';update();[...root.querySelectorAll('[data-review-sizes] input')].find(candidate=>candidate.value===value)?.focus({preventScroll:true});});label.append(input,span);return label;}));
     root.querySelectorAll('a[data-swatch-name]').forEach(a=>{const selected=path(a.href)===path(state.product.url||`/products/${state.product.handle}`);a.classList.toggle('is-active',selected);a.setAttribute('aria-pressed',String(selected));a.setAttribute('aria-disabled',String(state.adding));});
     const add=root.querySelector('[data-review-add]');add.disabled=!variant||state.loading||state.adding;add.textContent=state.loading?root.dataset.loading:state.adding?root.dataset.adding:variant?root.dataset.add:root.dataset.choose;
     root.querySelector('[data-review-status]').textContent=state.error||(state.loading?root.dataset.loading:!variant?root.dataset.choose:'');
     const selection=root.querySelector('[data-review-selection]');if(selection)selection.textContent=`${state.colour} · ${state.size===null?root.dataset.choose:state.size} · ${money(display.price)}`;
     const sticky=root.querySelector('[data-review-sticky-add]');if(sticky){sticky.disabled=state.loading||state.adding;sticky.textContent=variant?root.dataset.add:root.dataset.choose;}
     const detail=root.querySelector('[data-review-detail]');detail.href=state.product.url||`/products/${state.product.handle}`;
   });
 };
 const renderImages=product=>roots.forEach(root=>{
   const viewport=root.querySelector('[data-review-images]');viewport.replaceChildren(...product.images.slice(0,8).map((image,index)=>{const source=typeof image==='string'?image:image.src;const img=document.createElement('img');const url=new URL(source,location.origin);url.searchParams.set('width','1200');img.src=url.href;img.alt=`${product.title} — ${index+1}`;img.width=960;img.height=1200;img.loading=index?'lazy':'eager';return img;}));viewport.scrollTo({left:0,behavior:'instant'});root.querySelector('[data-review-count]').textContent=`1 / ${Math.min(product.images.length,8)}`;
 });
 roots.forEach(root=>{
   root.querySelector('[data-review-swatches]').addEventListener('click',async event=>{
     const swatch=event.target.closest('a[data-swatch-name]');if(!swatch)return;event.preventDefault();if(state.adding)return;
     const request=++state.request;state.controller?.abort();const controller=new AbortController();state.controller=controller;const timeout=setTimeout(()=>controller.abort(),15000);state.loading=true;state.error='';update();
     try{
       const url=new URL(swatch.href,location.origin);if(url.origin!==location.origin||!url.pathname.includes('/products/'))throw new Error();url.pathname+='.js';url.search='';
       const response=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});if(!response.ok)throw new Error();const product=await response.json();if(!product.variants?.length||!product.images?.length||!product.options.some(o=>/size/i.test(optionName(o))))throw new Error();
       const image=new Image();image.src=product.images[0];await Promise.race([image.decode(),new Promise((_,reject)=>setTimeout(reject,10000))]);if(request!==state.request)return;
       const nextIndex=product.options.findIndex(o=>/size/i.test(optionName(o)));if(state.size!==null&&!product.variants.some(v=>v.available&&normal(v.options[nextIndex])===state.size))state.size=null;
       state.product=product;state.colour=swatch.dataset.swatchName;state.loading=false;renderImages(product);update();
     }catch(error){if(request!==state.request)return;state.loading=false;state.error=root.dataset.error;update();}finally{clearTimeout(timeout);}
   });
   const viewport=root.querySelector('[data-review-images]');const move=direction=>{const images=[...viewport.querySelectorAll('img')];const index=Math.max(0,Math.min(images.length-1,Math.round(viewport.scrollLeft/(viewport.clientWidth+10))+direction));viewport.scrollTo({left:index*(viewport.clientWidth+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
   root.querySelector('[data-review-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-review-next]').addEventListener('click',()=>move(1));viewport.addEventListener('scroll',()=>{root.querySelector('[data-review-count]').textContent=`${Math.min(viewport.children.length,Math.round(viewport.scrollLeft/(viewport.clientWidth+10))+1)} / ${viewport.children.length}`;},{passive:true});
   root.querySelector('[data-review-form]').addEventListener('submit',async event=>{
     event.preventDefault();const variant=getVariant();if(!variant||state.loading||state.adding)return;state.adding=true;state.error='';update();const data=new FormData();data.append('id',variant.id);data.append('quantity','1');
     try{const helper=window.Alpine?.store?.('xCartHelper');if(helper){data.append('sections',helper.getSectionsToRender().map(section=>section.id));data.append('sections_url',location.pathname);}const response=await fetch(window.Eurus?.cart_add_url||`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/javascript','X-Requested-With':'XMLHttpRequest'},body:data});const result=await response.json();if(!response.ok||result.status===422)throw new Error(result.description||root.dataset.cartError);if(helper&&result.sections)helper.reRenderSections(result.sections);const notice=window.Alpine?.store?.('xCartNoti');if(notice?.enable)notice.setItem(result);const miniCart=window.Alpine?.store?.('xMiniCart');if(miniCart&&!notice?.enable)miniCart.openCart();document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));state.error=root.dataset.added;}catch(error){state.error=error.message||root.dataset.cartError;}finally{state.adding=false;update();}
   });
   root.querySelector('[data-review-sticky-add]')?.addEventListener('click',()=>{if(getVariant())root.querySelector('[data-review-form]').requestSubmit();else{const content=root.querySelector('.ob-review__content');content.scrollIntoView({behavior:'smooth',block:'start'});root.querySelector('[data-review-sizes] input:not(:disabled)')?.focus({preventScroll:true});}});
 });
 update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-signup-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DISMISS_KEY = 'ob-signup-dismissed:';
    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function readStore(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function writeStore(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        /* Private browsing or blocked storage — the popup still works, it just reappears. */
      }
    }

    function clearStore(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        /* No-op. */
      }
    }

    function setupOBSignup(root) {
      if (root.dataset.obSignupReady === 'true') return;
      root.dataset.obSignupReady = 'true';

      const dialog = root.querySelector('.ob-signup__dialog');
      const slot = root.querySelector('[data-ob-signup-slot]');
      const closers = Array.from(root.querySelectorAll('[data-ob-signup-close]'));
      const overlay = root.querySelector('[data-ob-signup-overlay]');

      if (!dialog) return;

      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const dismissKey = DISMISS_KEY + root.dataset.obSignupId;
      const reappearDays = parseInt(root.dataset.obSignupReappear, 10) || 0;

      let lastFocused = null;
      let armed = false;

      function remember() {
        if (readStore(dismissKey) === 'never') return;
        if (reappearDays <= 0) {
          writeStore(dismissKey, 'never');
          return;
        }
        writeStore(dismissKey, String(Date.now() + reappearDays * 86400000));
      }

      function dismissed() {
        const stored = readStore(dismissKey);
        if (!stored) return false;
        if (stored === 'never') return true;
        const until = parseInt(stored, 10);
        if (!until || Number.isNaN(until)) return false;
        if (Date.now() >= until) {
          clearStore(dismissKey);
          return false;
        }
        return true;
      }

      function focusable() {
        return Array.from(dialog.querySelectorAll(FOCUSABLE)).filter(
          (el) => el.offsetParent !== null || el === document.activeElement
        );
      }

      function trapFocus(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const items = focusable();
        if (items.length === 0) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function open() {
        if (root.classList.contains('is-open')) return;
        lastFocused = document.activeElement;
        root.hidden = false;
        root.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => root.classList.add('is-visible'));
        document.addEventListener('keydown', trapFocus);
        const target = focusable()[0];
        if (target) {
          window.setTimeout(() => target.focus({ preventScroll: true }), 60);
        }
      }

      function close() {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-visible');
        document.removeEventListener('keydown', trapFocus);
        document.body.style.overflow = '';
        window.setTimeout(() => {
          root.classList.remove('is-open');
          root.hidden = true;
        }, 220);
        if (!designMode) remember();
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
      }

      function threshold() {
        const mobileDepth = parseInt(root.dataset.obSignupDepthMobile, 10) || 0;
        const desktopDepth = parseInt(root.dataset.obSignupDepth, 10) || 0;
        if (mobileDepth > 0 && window.matchMedia('(max-width: 749px)').matches) return mobileDepth;
        return desktopDepth;
      }

      function onScroll() {
        if (window.scrollY < threshold()) return;
        disarm();
        open();
      }

      function disarm() {
        if (!armed) return;
        armed = false;
        window.removeEventListener('scroll', onScroll);
      }

      function arm() {
        if (armed) return;
        armed = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      closers.forEach((closer) => closer.addEventListener('click', close));
      if (overlay) overlay.addEventListener('click', close);

      // Best effort: Shopify Forms publishes no submit event, so retire the popup
      // when a form inside the slot submits. If Forms ever stops emitting a native
      // submit event, the only cost is that the popup returns after the dismissal
      // window instead of for good.
      if (slot) {
        slot.addEventListener(
          'submit',
          () => {
            writeStore(dismissKey, 'never');
          },
          true
        );
      }

      if (designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target === root || event.target.contains(root)) open();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.target === root || event.target.contains(root)) close();
        });
        return;
      }

      if (root.dataset.obSignupHasForm !== 'true') return;
      if (root.dataset.obSignupIsCustomer === 'true') return;
      if (root.dataset.obSignupMobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;
      if (dismissed()) return;

      arm();
    }

    function initOBSignup(container) {
      const scope = container || document;
      scope.querySelectorAll('[data-ob-signup]').forEach(setupOBSignup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOBSignup());
    } else {
      initOBSignup();
    }

    document.addEventListener('shopify:section:load', (event) => initOBSignup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-starter-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ob-starter-rail]').forEach((rail) => {
      if (rail.dataset.obStarterRailReady === 'true') return;
      rail.dataset.obStarterRailReady = 'true';

      const root = rail.closest('.ob-starter');
      if (!root) return;
      const counter = root.querySelector('[data-ob-starter-counter]');
      const progress = root.querySelector('[data-ob-starter-progress]');
      let frame = null;

      const update = () => {
        frame = null;
        // Tiles past the mobile limit are display:none on a phone and laid out
        // again on a wider screen, so the count is read from what is showing.
        const cards = Array.from(rail.children).filter((card) => card.offsetParent !== null);
        if (!cards.length) return;

        let activeIndex = 0;
        let closest = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.offsetLeft - rail.scrollLeft);
          if (distance < closest) {
            closest = distance;
            activeIndex = index;
          }
        });

        if (counter) {
          counter.textContent =
            String(activeIndex + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
        }
        if (progress) {
          progress.style.setProperty('--ob-starter-rail-count', cards.length);
          progress.style.setProperty('--ob-starter-rail-index', activeIndex);
        }
      };

      rail.addEventListener(
        'scroll',
        () => {
          if (frame) return;
          frame = window.requestAnimationFrame(update);
        },
        { passive: true }
      );
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-the-vault"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!customElements.get('vault-return-card')) {
      class VaultReturnCard extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.button = this.querySelector('[data-vault-vote]');
          this.onVote = this.onVote.bind(this);
          this.button?.addEventListener('click', this.onVote);
          this.renderCount(false);
          if (this.readVote()) this.applyVote(false);
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.onVote);
        }

        storageKey() {
          return `${this.dataset.storagePrefix || 'onebone-vault-vote'}:${this.dataset.archiveId}`;
        }

        readVote() {
          try {
            return JSON.parse(window.localStorage.getItem(this.storageKey()));
          } catch (error) {
            return null;
          }
        }

        saveVote(payload) {
          try {
            window.localStorage.setItem(this.storageKey(), JSON.stringify(payload));
          } catch (error) {
            return;
          }
        }

        baseVotes() {
          const votes = Number.parseInt(this.dataset.baseVotes || '0', 10);
          return Number.isFinite(votes) ? votes : 0;
        }

        renderCount(incremented) {
          const count = this.querySelector('[data-vault-vote-count]');
          if (count) count.textContent = (this.baseVotes() + (incremented ? 1 : 0)).toLocaleString();
        }

        onVote() {
          if (this.readVote() || this.button?.classList.contains('is-voted')) return;
          const payload = {
            sectionId: this.closest('[data-section-id]')?.dataset.sectionId || '',
            archiveId: this.dataset.archiveId,
            title: this.dataset.archiveTitle,
            baseVotes: this.baseVotes(),
            votedAt: new Date().toISOString(),
          };
          this.saveVote(payload);
          this.applyVote(true);
          this.dispatchEvent(new CustomEvent('onebone:vault:vote', { bubbles: true, detail: payload }));
        }

        applyVote(animate) {
          this.renderCount(true);
          this.button?.classList.add('is-voted');
          this.button?.setAttribute('aria-pressed', 'true');
          const label = this.querySelector('[data-vault-vote-label]');
          const root = this.closest('onebone-the-vault');
          if (label && root?.dataset.votedLabel) label.textContent = root.dataset.votedLabel;
          if (animate) {
            this.button?.classList.add('is-popping');
            window.setTimeout(() => this.button?.classList.remove('is-popping'), 430);
          }
        }
      }
      customElements.define('vault-return-card', VaultReturnCard);
    }

    if (!customElements.get('onebone-the-vault')) {
      class OneBoneTheVault extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.classList.add('is-visible');
            return;
          }
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0]?.isIntersecting) return;
              this.classList.add('is-visible');
              this.observer.disconnect();
            },
            { threshold: 0.08 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
      customElements.define('onebone-the-vault', OneBoneTheVault);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
